import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ece25026 = () => interopDefault(import('../../../pages/_lang/404.vue' /* webpackChunkName: "pages/_lang/404" */))
const _366c0985 = () => interopDefault(import('../../../pages/_lang/about/index.vue' /* webpackChunkName: "pages/_lang/about/index" */))
const _70fd8dbc = () => interopDefault(import('../../../pages/_lang/additional-services/index.vue' /* webpackChunkName: "pages/_lang/additional-services/index" */))
const _3c95d180 = () => interopDefault(import('../../../pages/_lang/blog/index.vue' /* webpackChunkName: "pages/_lang/blog/index" */))
const _7fcf296d = () => interopDefault(import('../../../pages/_lang/careers/index.vue' /* webpackChunkName: "pages/_lang/careers/index" */))
const _11ca5b18 = () => interopDefault(import('../../../pages/_lang/contact/index.vue' /* webpackChunkName: "pages/_lang/contact/index" */))
const _03bd7326 = () => interopDefault(import('../../../pages/_lang/culture/index.vue' /* webpackChunkName: "pages/_lang/culture/index" */))
const _3d533ccb = () => interopDefault(import('../../../pages/_lang/debug/index.vue' /* webpackChunkName: "pages/_lang/debug/index" */))
const _bba8086a = () => interopDefault(import('../../../pages/_lang/engineering/index.vue' /* webpackChunkName: "pages/_lang/engineering/index" */))
const _bfd4da80 = () => interopDefault(import('../../../pages/_lang/europe/index.vue' /* webpackChunkName: "pages/_lang/europe/index" */))
const _f4a8b91e = () => interopDefault(import('../../../pages/_lang/news/index.vue' /* webpackChunkName: "pages/_lang/news/index" */))
const _5922c0de = () => interopDefault(import('../../../pages/_lang/platform/index.vue' /* webpackChunkName: "pages/_lang/platform/index" */))
const _02502aff = () => interopDefault(import('../../../pages/_lang/united-kingdom/index.vue' /* webpackChunkName: "pages/_lang/united-kingdom/index" */))
const _4f777424 = () => interopDefault(import('../../../pages/_lang/united-states/index.vue' /* webpackChunkName: "pages/_lang/united-states/index" */))
const _1bc67408 = () => interopDefault(import('../../../pages/_lang/about/approach/index.vue' /* webpackChunkName: "pages/_lang/about/approach/index" */))
const _45ee81d6 = () => interopDefault(import('../../../pages/_lang/about/awards/index.vue' /* webpackChunkName: "pages/_lang/about/awards/index" */))
const _4d095c78 = () => interopDefault(import('../../../pages/_lang/about/customer-stories/index.vue' /* webpackChunkName: "pages/_lang/about/customer-stories/index" */))
const _3b78dd90 = () => interopDefault(import('../../../pages/_lang/about/net-zero/index.vue' /* webpackChunkName: "pages/_lang/about/net-zero/index" */))
const _77bb8aaa = () => interopDefault(import('../../../pages/_lang/about/our-story/index.vue' /* webpackChunkName: "pages/_lang/about/our-story/index" */))
const _0ea3f14b = () => interopDefault(import('../../../pages/_lang/about/partners/index.vue' /* webpackChunkName: "pages/_lang/about/partners/index" */))
const _56542a06 = () => interopDefault(import('../../../pages/_lang/about/team/index.vue' /* webpackChunkName: "pages/_lang/about/team/index" */))
const _1f1f9aa8 = () => interopDefault(import('../../../pages/_lang/additional-services/account-management/index.vue' /* webpackChunkName: "pages/_lang/additional-services/account-management/index" */))
const _5ce0741e = () => interopDefault(import('../../../pages/_lang/additional-services/cop/index.vue' /* webpackChunkName: "pages/_lang/additional-services/cop/index" */))
const _42580a51 = () => interopDefault(import('../../../pages/_lang/additional-services/fraud/index.vue' /* webpackChunkName: "pages/_lang/additional-services/fraud/index" */))
const _f3f26d20 = () => interopDefault(import('../../../pages/_lang/additional-services/metrics/index.vue' /* webpackChunkName: "pages/_lang/additional-services/metrics/index" */))
const _2a60c739 = () => interopDefault(import('../../../pages/_lang/additional-services/on-us/index.vue' /* webpackChunkName: "pages/_lang/additional-services/on-us/index" */))
const _0b0df024 = () => interopDefault(import('../../../pages/_lang/additional-services/orchestration/index.vue' /* webpackChunkName: "pages/_lang/additional-services/orchestration/index" */))
const _f56d7cf8 = () => interopDefault(import('../../../pages/_lang/additional-services/vop/index.vue' /* webpackChunkName: "pages/_lang/additional-services/vop/index" */))
const _0b77b45f = () => interopDefault(import('../../../pages/_lang/blog/culture/index.vue' /* webpackChunkName: "pages/_lang/blog/culture/index" */))
const _57fe0ef8 = () => interopDefault(import('../../../pages/_lang/blog/engineering/index.vue' /* webpackChunkName: "pages/_lang/blog/engineering/index" */))
const _64bec577 = () => interopDefault(import('../../../pages/_lang/careers/vacancies/index.vue' /* webpackChunkName: "pages/_lang/careers/vacancies/index" */))
const _24f7655e = () => interopDefault(import('../../../pages/_lang/contact/error/index.vue' /* webpackChunkName: "pages/_lang/contact/error/index" */))
const _78408e05 = () => interopDefault(import('../../../pages/_lang/contact/thank-you/index.vue' /* webpackChunkName: "pages/_lang/contact/thank-you/index" */))
const _51dc15d3 = () => interopDefault(import('../../../pages/_lang/engineering/accreditations/index.vue' /* webpackChunkName: "pages/_lang/engineering/accreditations/index" */))
const _420b80b5 = () => interopDefault(import('../../../pages/_lang/engineering/content/index.vue' /* webpackChunkName: "pages/_lang/engineering/content/index" */))
const _ba34067c = () => interopDefault(import('../../../pages/_lang/engineering/life-at-form3/index.vue' /* webpackChunkName: "pages/_lang/engineering/life-at-form3/index" */))
const _5f8b16f0 = () => interopDefault(import('../../../pages/_lang/europe/sepa/index.vue' /* webpackChunkName: "pages/_lang/europe/sepa/index" */))
const _614a6c7a = () => interopDefault(import('../../../pages/_lang/europe/sepa-credit-transfer/index.vue' /* webpackChunkName: "pages/_lang/europe/sepa-credit-transfer/index" */))
const _655b697a = () => interopDefault(import('../../../pages/_lang/europe/sepa-direct-debit/index.vue' /* webpackChunkName: "pages/_lang/europe/sepa-direct-debit/index" */))
const _e5ab10c8 = () => interopDefault(import('../../../pages/_lang/europe/sepa-instant/index.vue' /* webpackChunkName: "pages/_lang/europe/sepa-instant/index" */))
const _bc77c5c6 = () => interopDefault(import('../../../pages/_lang/legal/cookie-policy/index.vue' /* webpackChunkName: "pages/_lang/legal/cookie-policy/index" */))
const _8897ad8a = () => interopDefault(import('../../../pages/_lang/legal/data-privacy-statement/index.vue' /* webpackChunkName: "pages/_lang/legal/data-privacy-statement/index" */))
const _332e933a = () => interopDefault(import('../../../pages/_lang/legal/license/index.vue' /* webpackChunkName: "pages/_lang/legal/license/index" */))
const _56042ab8 = () => interopDefault(import('../../../pages/_lang/legal/modern-slavery/index.vue' /* webpackChunkName: "pages/_lang/legal/modern-slavery/index" */))
const _3185e334 = () => interopDefault(import('../../../pages/_lang/legal/recruitment-data-policy/index.vue' /* webpackChunkName: "pages/_lang/legal/recruitment-data-policy/index" */))
const _30274ab0 = () => interopDefault(import('../../../pages/_lang/legal/terms-and-conditions/index.vue' /* webpackChunkName: "pages/_lang/legal/terms-and-conditions/index" */))
const _5d24da36 = () => interopDefault(import('../../../pages/_lang/news/payment-insights/index.vue' /* webpackChunkName: "pages/_lang/news/payment-insights/index" */))
const _4127274a = () => interopDefault(import('../../../pages/_lang/news/press-releases/index.vue' /* webpackChunkName: "pages/_lang/news/press-releases/index" */))
const _9dd7aca8 = () => interopDefault(import('../../../pages/_lang/platform/connect/index.vue' /* webpackChunkName: "pages/_lang/platform/connect/index" */))
const _8760e3ce = () => interopDefault(import('../../../pages/_lang/platform/escrow/index.vue' /* webpackChunkName: "pages/_lang/platform/escrow/index" */))
const _3ab4e910 = () => interopDefault(import('../../../pages/_lang/platform/international/index.vue' /* webpackChunkName: "pages/_lang/platform/international/index" */))
const _70b7cd30 = () => interopDefault(import('../../../pages/_lang/platform/multicloud/index.vue' /* webpackChunkName: "pages/_lang/platform/multicloud/index" */))
const _1eeaa5d8 = () => interopDefault(import('../../../pages/_lang/platform/security/index.vue' /* webpackChunkName: "pages/_lang/platform/security/index" */))
const _59fe6e86 = () => interopDefault(import('../../../pages/_lang/platform/simulator/index.vue' /* webpackChunkName: "pages/_lang/platform/simulator/index" */))
const _f0d83508 = () => interopDefault(import('../../../pages/_lang/united-kingdom/uk/index.vue' /* webpackChunkName: "pages/_lang/united-kingdom/uk/index" */))
const _1d4db490 = () => interopDefault(import('../../../pages/_lang/united-kingdom/uk-instant/index.vue' /* webpackChunkName: "pages/_lang/united-kingdom/uk-instant/index" */))
const _c51b3782 = () => interopDefault(import('../../../pages/_lang/united-states/us/index.vue' /* webpackChunkName: "pages/_lang/united-states/us/index" */))
const _13eec053 = () => interopDefault(import('../../../pages/_lang/united-states/us-instant/index.vue' /* webpackChunkName: "pages/_lang/united-states/us-instant/index" */))
const _21de9b94 = () => interopDefault(import('../../../pages/_lang/platform/international/swift/index.vue' /* webpackChunkName: "pages/_lang/platform/international/swift/index" */))
const _3c6f0d38 = () => interopDefault(import('../../../pages/_lang/careers/vacancies/_jobId.vue' /* webpackChunkName: "pages/_lang/careers/vacancies/_jobId" */))
const _0f30e057 = () => interopDefault(import('../../../pages/_lang/news/press-releases/_.vue' /* webpackChunkName: "pages/_lang/news/press-releases/_" */))
const _6f74e943 = () => interopDefault(import('../../../pages/_lang/news/payment-insights/_.vue' /* webpackChunkName: "pages/_lang/news/payment-insights/_" */))
const _7ab26e2a = () => interopDefault(import('../../../pages/_lang/engineering/who-we-are/_.vue' /* webpackChunkName: "pages/_lang/engineering/who-we-are/_" */))
const _1878a742 = () => interopDefault(import('../../../pages/_lang/engineering/content/_.vue' /* webpackChunkName: "pages/_lang/engineering/content/_" */))
const _52c85e91 = () => interopDefault(import('../../../pages/_lang/blog/engineering/_.vue' /* webpackChunkName: "pages/_lang/blog/engineering/_" */))
const _2ed58028 = () => interopDefault(import('../../../pages/_lang/blog/culture/_.vue' /* webpackChunkName: "pages/_lang/blog/culture/_" */))
const _459eabdc = () => interopDefault(import('../../../pages/_lang/landing/_.vue' /* webpackChunkName: "pages/_lang/landing/_" */))
const _38407230 = () => interopDefault(import('../../../pages/_lang/campaigns/_.vue' /* webpackChunkName: "pages/_lang/campaigns/_" */))
const _f550116e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f6237172 = () => interopDefault(import('../../../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _ece25026,
    name: "404"
  }, {
    path: "/about",
    component: _366c0985,
    name: "about"
  }, {
    path: "/additional-services",
    component: _70fd8dbc,
    name: "additional-services"
  }, {
    path: "/blog",
    component: _3c95d180,
    name: "blog"
  }, {
    path: "/careers",
    component: _7fcf296d,
    name: "careers"
  }, {
    path: "/contact",
    component: _11ca5b18,
    name: "contact"
  }, {
    path: "/culture",
    component: _03bd7326,
    name: "culture"
  }, {
    path: "/debug",
    component: _3d533ccb,
    name: "debug"
  }, {
    path: "/engineering",
    component: _bba8086a,
    name: "engineering"
  }, {
    path: "/europe",
    component: _bfd4da80,
    name: "europe"
  }, {
    path: "/news",
    component: _f4a8b91e,
    name: "news"
  }, {
    path: "/platform",
    component: _5922c0de,
    name: "platform"
  }, {
    path: "/united-kingdom",
    component: _02502aff,
    name: "united-kingdom"
  }, {
    path: "/united-states",
    component: _4f777424,
    name: "united-states"
  }, {
    path: "/about/approach",
    component: _1bc67408,
    name: "about-approach"
  }, {
    path: "/about/awards",
    component: _45ee81d6,
    name: "about-awards"
  }, {
    path: "/about/customer-stories",
    component: _4d095c78,
    name: "about-customer-stories"
  }, {
    path: "/about/net-zero",
    component: _3b78dd90,
    name: "about-net-zero"
  }, {
    path: "/about/our-story",
    component: _77bb8aaa,
    name: "about-our-story"
  }, {
    path: "/about/partners",
    component: _0ea3f14b,
    name: "about-partners"
  }, {
    path: "/about/team",
    component: _56542a06,
    name: "about-team"
  }, {
    path: "/additional-services/account-management",
    component: _1f1f9aa8,
    name: "additional-services-account-management"
  }, {
    path: "/additional-services/cop",
    component: _5ce0741e,
    name: "additional-services-cop"
  }, {
    path: "/additional-services/fraud",
    component: _42580a51,
    name: "additional-services-fraud"
  }, {
    path: "/additional-services/metrics",
    component: _f3f26d20,
    name: "additional-services-metrics"
  }, {
    path: "/additional-services/on-us",
    component: _2a60c739,
    name: "additional-services-on-us"
  }, {
    path: "/additional-services/orchestration",
    component: _0b0df024,
    name: "additional-services-orchestration"
  }, {
    path: "/additional-services/vop",
    component: _f56d7cf8,
    name: "additional-services-vop"
  }, {
    path: "/blog/culture",
    component: _0b77b45f,
    name: "blog-culture"
  }, {
    path: "/blog/engineering",
    component: _57fe0ef8,
    name: "blog-engineering"
  }, {
    path: "/careers/vacancies",
    component: _64bec577,
    name: "careers-vacancies"
  }, {
    path: "/contact/error",
    component: _24f7655e,
    name: "contact-error"
  }, {
    path: "/contact/thank-you",
    component: _78408e05,
    name: "contact-thank-you"
  }, {
    path: "/engineering/accreditations",
    component: _51dc15d3,
    name: "engineering-accreditations"
  }, {
    path: "/engineering/content",
    component: _420b80b5,
    name: "engineering-content"
  }, {
    path: "/engineering/life-at-form3",
    component: _ba34067c,
    name: "engineering-life-at-form3"
  }, {
    path: "/europe/sepa",
    component: _5f8b16f0,
    name: "europe-sepa"
  }, {
    path: "/europe/sepa-credit-transfer",
    component: _614a6c7a,
    name: "europe-sepa-credit-transfer"
  }, {
    path: "/europe/sepa-direct-debit",
    component: _655b697a,
    name: "europe-sepa-direct-debit"
  }, {
    path: "/europe/sepa-instant",
    component: _e5ab10c8,
    name: "europe-sepa-instant"
  }, {
    path: "/legal/cookie-policy",
    component: _bc77c5c6,
    name: "legal-cookie-policy"
  }, {
    path: "/legal/data-privacy-statement",
    component: _8897ad8a,
    name: "legal-data-privacy-statement"
  }, {
    path: "/legal/license",
    component: _332e933a,
    name: "legal-license"
  }, {
    path: "/legal/modern-slavery",
    component: _56042ab8,
    name: "legal-modern-slavery"
  }, {
    path: "/legal/recruitment-data-policy",
    component: _3185e334,
    name: "legal-recruitment-data-policy"
  }, {
    path: "/legal/terms-and-conditions",
    component: _30274ab0,
    name: "legal-terms-and-conditions"
  }, {
    path: "/news/payment-insights",
    component: _5d24da36,
    name: "news-payment-insights"
  }, {
    path: "/news/press-releases",
    component: _4127274a,
    name: "news-press-releases"
  }, {
    path: "/platform/connect",
    component: _9dd7aca8,
    name: "platform-connect"
  }, {
    path: "/platform/escrow",
    component: _8760e3ce,
    name: "platform-escrow"
  }, {
    path: "/platform/international",
    component: _3ab4e910,
    name: "platform-international"
  }, {
    path: "/platform/multicloud",
    component: _70b7cd30,
    name: "platform-multicloud"
  }, {
    path: "/platform/security",
    component: _1eeaa5d8,
    name: "platform-security"
  }, {
    path: "/platform/simulator",
    component: _59fe6e86,
    name: "platform-simulator"
  }, {
    path: "/united-kingdom/uk",
    component: _f0d83508,
    name: "united-kingdom-uk"
  }, {
    path: "/united-kingdom/uk-instant",
    component: _1d4db490,
    name: "united-kingdom-uk-instant"
  }, {
    path: "/united-states/us",
    component: _c51b3782,
    name: "united-states-us"
  }, {
    path: "/united-states/us-instant",
    component: _13eec053,
    name: "united-states-us-instant"
  }, {
    path: "/platform/international/swift",
    component: _21de9b94,
    name: "platform-international-swift"
  }, {
    path: "/careers/vacancies/:jobId/:jobTitle?",
    component: _3c6f0d38,
    name: "careers-vacancies-jobId"
  }, {
    path: "/news/press-releases/*",
    component: _0f30e057,
    name: "news-press-releases-all"
  }, {
    path: "/news/payment-insights/*",
    component: _6f74e943,
    name: "news-payment-insights-all"
  }, {
    path: "/engineering/who-we-are/*",
    component: _7ab26e2a,
    name: "engineering-who-we-are-all"
  }, {
    path: "/engineering/content/*",
    component: _1878a742,
    name: "engineering-content-all"
  }, {
    path: "/blog/engineering/*",
    component: _52c85e91,
    name: "blog-engineering-all"
  }, {
    path: "/blog/culture/*",
    component: _2ed58028,
    name: "blog-culture-all"
  }, {
    path: "/landing/*",
    component: _459eabdc,
    name: "landing-all"
  }, {
    path: "/campaigns/*",
    component: _38407230,
    name: "campaigns-all"
  }, {
    path: "/news/payment-insights/real-time-payments-a-revenue-opportunity-for-mid-sized-banks",
    component: _6f74e943,
    name: "news/payment-insights-real-time-payments-a-revenue-opportunity-for-mid-sized-banks"
  }, {
    path: "/news/payment-insights/verification-of-payee-deadline-what-banks-must-do-to-meet-epc-requirements",
    component: _6f74e943,
    name: "news/payment-insights-verification-of-payee-deadline-what-banks-must-do-to-meet-epc-requirements"
  }, {
    path: "/news/payment-insights/why-multicloud-is-the-future",
    component: _6f74e943,
    name: "news/payment-insights-why-multicloud-is-the-future"
  }, {
    path: "/news/payment-insights/why-orchestration-is-a-key-driver-in-payment-modernisation",
    component: _6f74e943,
    name: "news/payment-insights-why-orchestration-is-a-key-driver-in-payment-modernisation"
  }, {
    path: "/news/payment-insights/verification-of-payee-regulation-overview",
    component: _6f74e943,
    name: "news/payment-insights-verification-of-payee-regulation-overview"
  }, {
    path: "/news/payment-insights/why-mid-sized-banks-cant-afford-to-ignore-real-time-payments",
    component: _6f74e943,
    name: "news/payment-insights-why-mid-sized-banks-cant-afford-to-ignore-real-time-payments"
  }, {
    path: "/news/payment-insights/resilient-real-time-payments-ecosystem",
    component: _6f74e943,
    name: "news/payment-insights-resilient-real-time-payments-ecosystem"
  }, {
    path: "/news/payment-insights/harnessing-instant-payments-in-the-us-with-the-rtp-network",
    component: _6f74e943,
    name: "news/payment-insights-harnessing-instant-payments-in-the-us-with-the-rtp-network"
  }, {
    path: "/news/payment-insights/key-us-payment-trends-in-2025-and-beyond-that-banks-need-to-be-aware-of",
    component: _6f74e943,
    name: "news/payment-insights-key-us-payment-trends-in-2025-and-beyond-that-banks-need-to-be-aware-of"
  }, {
    path: "/news/payment-insights/fednows-first-birthday-reflects-strong-faster-payments-progress",
    component: _6f74e943,
    name: "news/payment-insights-fednows-first-birthday-reflects-strong-faster-payments-progress"
  }, {
    path: "/news/payment-insights/year-in-review-2024-payment-landscape",
    component: _6f74e943,
    name: "news/payment-insights-year-in-review-2024-payment-landscape"
  }, {
    path: "/news/payment-insights/sepa-instant-payments-2025-rulebook-updates",
    component: _6f74e943,
    name: "news/payment-insights-sepa-instant-payments-2025-rulebook-updates"
  }, {
    path: "/news/payment-insights/compliance-with-the-eu-digital-operational-resilience-act",
    component: _6f74e943,
    name: "news/payment-insights-compliance-with-the-eu-digital-operational-resilience-act"
  }, {
    path: "/news/payment-insights/building-operational-resilience",
    component: _6f74e943,
    name: "news/payment-insights-building-operational-resilience"
  }, {
    path: "/news/payment-insights/how-traditional-banking-tech-infrastructure-is-being-transformed",
    component: _6f74e943,
    name: "news/payment-insights-how-traditional-banking-tech-infrastructure-is-being-transformed"
  }, {
    path: "/news/payment-insights/how-form3s-metrics-service-opens-up-granular-insights",
    component: _6f74e943,
    name: "news/payment-insights-how-form3s-metrics-service-opens-up-granular-insights"
  }, {
    path: "/news/payment-insights/how-multi-cloud-supports-operational-resilience-in-payments",
    component: _6f74e943,
    name: "news/payment-insights-how-multi-cloud-supports-operational-resilience-in-payments"
  }, {
    path: "/news/payment-insights/innovation-and-regulation",
    component: _6f74e943,
    name: "news/payment-insights-innovation-and-regulation"
  }, {
    path: "/news/payment-insights/key-to-uk-modernisation-for-banks",
    component: _6f74e943,
    name: "news/payment-insights-key-to-uk-modernisation-for-banks"
  }, {
    path: "/news/payment-insights/vop",
    component: _6f74e943,
    name: "news/payment-insights-vop"
  }, {
    path: "/news/payment-insights/psd3-and-fintechs",
    component: _6f74e943,
    name: "news/payment-insights-psd3-and-fintechs"
  }, {
    path: "/news/payment-insights/multicloud-approach-to-payments",
    component: _6f74e943,
    name: "news/payment-insights-multicloud-approach-to-payments"
  }, {
    path: "/news/payment-insights/webinar-rethinking-a-platform-approach-to-payments",
    component: _6f74e943,
    name: "news/payment-insights-webinar-rethinking-a-platform-approach-to-payments"
  }, {
    path: "/news/payment-insights/navigating-the-digital-shift",
    component: _6f74e943,
    name: "news/payment-insights-navigating-the-digital-shift"
  }, {
    path: "/news/payment-insights/real-time-payments-need-orchestration-layer-to-solve-interoperability-gap",
    component: _6f74e943,
    name: "news/payment-insights-real-time-payments-need-orchestration-layer-to-solve-interoperability-gap"
  }, {
    path: "/news/payment-insights/pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards",
    component: _6f74e943,
    name: "news/payment-insights-pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards"
  }, {
    path: "/news/payment-insights/misconceptions-of-payment-orchestration",
    component: _6f74e943,
    name: "news/payment-insights-misconceptions-of-payment-orchestration"
  }, {
    path: "/news/payment-insights/apis-promise-to-make-instant-payment-systems-interoperable",
    component: _6f74e943,
    name: "news/payment-insights-apis-promise-to-make-instant-payment-systems-interoperable"
  }, {
    path: "/news/payment-insights/demystifying-payment-modernization",
    component: _6f74e943,
    name: "news/payment-insights-demystifying-payment-modernization"
  }, {
    path: "/news/payment-insights/demystifying-payment-modernization-separating-fact-from-fiction",
    component: _6f74e943,
    name: "news/payment-insights-demystifying-payment-modernization-separating-fact-from-fiction"
  }, {
    path: "/news/payment-insights/elevating-payment-standards-with-form3-a-vision-of-efficiency-and-resilience",
    component: _6f74e943,
    name: "news/payment-insights-elevating-payment-standards-with-form3-a-vision-of-efficiency-and-resilience"
  }, {
    path: "/news/payment-insights/what-will-be-the-key-trends-in-payments-in-2024",
    component: _6f74e943,
    name: "news/payment-insights-what-will-be-the-key-trends-in-payments-in-2024"
  }, {
    path: "/news/payment-insights/what-banks-and-psps-need-to-do-in-2024-to-enable-seamless-payments",
    component: _6f74e943,
    name: "news/payment-insights-what-banks-and-psps-need-to-do-in-2024-to-enable-seamless-payments"
  }, {
    path: "/news/payment-insights/form3-payments-trends-banks-need-to-be-aware-of-in-2024",
    component: _6f74e943,
    name: "news/payment-insights-form3-payments-trends-banks-need-to-be-aware-of-in-2024"
  }, {
    path: "/news/payment-insights/industry-focus-trends-in-fintech-that-drive-growth",
    component: _6f74e943,
    name: "news/payment-insights-industry-focus-trends-in-fintech-that-drive-growth"
  }, {
    path: "/news/payment-insights/new-use-cases-needed-to-drive-instant-payments-momentum-worldwide",
    component: _6f74e943,
    name: "news/payment-insights-new-use-cases-needed-to-drive-instant-payments-momentum-worldwide"
  }, {
    path: "/news/payment-insights/five-months-in-fednow-is-doing-what-it-was-planned-to-do",
    component: _6f74e943,
    name: "news/payment-insights-five-months-in-fednow-is-doing-what-it-was-planned-to-do"
  }, {
    path: "/news/payment-insights/b2b-payments-need-foundational-infrastructure",
    component: _6f74e943,
    name: "news/payment-insights-b2b-payments-need-foundational-infrastructure"
  }, {
    path: "/news/payment-insights/fedwire-will-get-boost-from-iso-200221",
    component: _6f74e943,
    name: "news/payment-insights-fedwire-will-get-boost-from-iso-200221"
  }, {
    path: "/news/payment-insights/unleash-the-power-of-iso-20022",
    component: _6f74e943,
    name: "news/payment-insights-unleash-the-power-of-iso-20022"
  }, {
    path: "/news/payment-insights/unleashing-hyper-automation-the-next-frontier-in-payment-innovation",
    component: _6f74e943,
    name: "news/payment-insights-unleashing-hyper-automation-the-next-frontier-in-payment-innovation"
  }, {
    path: "/news/payment-insights/instant-payments-force-banks-to-examine-limitations-of-creaky-legacy-systems",
    component: _6f74e943,
    name: "news/payment-insights-instant-payments-force-banks-to-examine-limitations-of-creaky-legacy-systems"
  }, {
    path: "/news/payment-insights/why-psps-must-act-now-on-psr-requirements",
    component: _6f74e943,
    name: "news/payment-insights-why-psps-must-act-now-on-psr-requirements"
  }, {
    path: "/news/payment-insights/form3-announces-three-management-changes",
    component: _6f74e943,
    name: "news/payment-insights-form3-announces-three-management-changes"
  }, {
    path: "/news/payment-insights/understanding-fpad-a-game-changer-for-european-banks",
    component: _6f74e943,
    name: "news/payment-insights-understanding-fpad-a-game-changer-for-european-banks"
  }, {
    path: "/news/payment-insights/whitepaper-advancing-payment-innovation",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-advancing-payment-innovation"
  }, {
    path: "/news/payment-insights/real-time-payments-pave-way-for-further-adoption-of-platform-as-a-service-models",
    component: _6f74e943,
    name: "news/payment-insights-real-time-payments-pave-way-for-further-adoption-of-platform-as-a-service-models"
  }, {
    path: "/news/payment-insights/panel-real-time-ubiquity-and-connectivity-turn-payments-into-satisfaction-tools",
    component: _6f74e943,
    name: "news/payment-insights-panel-real-time-ubiquity-and-connectivity-turn-payments-into-satisfaction-tools"
  }, {
    path: "/news/payment-insights/gated-content-pymnts-livestream-interoperability",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-pymnts-livestream-interoperability"
  }, {
    path: "/news/payment-insights/enhancing-payment-security-in-the-uk-the-role-of-confirmation-of-payee",
    component: _6f74e943,
    name: "news/payment-insights-enhancing-payment-security-in-the-uk-the-role-of-confirmation-of-payee"
  }, {
    path: "/news/payment-insights/fednow-is-live-but-banks-face-integration-decisions",
    component: _6f74e943,
    name: "news/payment-insights-fednow-is-live-but-banks-face-integration-decisions"
  }, {
    path: "/news/payment-insights/challenge-of-real-time-integration",
    component: _6f74e943,
    name: "news/payment-insights-challenge-of-real-time-integration"
  }, {
    path: "/news/payment-insights/apis-revolutionize-connectivity-for-fis-and-set-stage-for-real-time-payments-success",
    component: _6f74e943,
    name: "news/payment-insights-apis-revolutionize-connectivity-for-fis-and-set-stage-for-real-time-payments-success"
  }, {
    path: "/news/payment-insights/back-office-overhaul-critical-to-survival-in-faster-payments-landscape",
    component: _6f74e943,
    name: "news/payment-insights-back-office-overhaul-critical-to-survival-in-faster-payments-landscape"
  }, {
    path: "/news/payment-insights/fednow-launch-pushes-banks-to-embrace-the-cloud",
    component: _6f74e943,
    name: "news/payment-insights-fednow-launch-pushes-banks-to-embrace-the-cloud"
  }, {
    path: "/news/payment-insights/gated-content-how-apis-are-reshaping-the-payments-landscape",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-how-apis-are-reshaping-the-payments-landscape"
  }, {
    path: "/news/payment-insights/fednow-is-approaching",
    component: _6f74e943,
    name: "news/payment-insights-fednow-is-approaching"
  }, {
    path: "/news/payment-insights/unravelling-psd3",
    component: _6f74e943,
    name: "news/payment-insights-unravelling-psd3"
  }, {
    path: "/news/payment-insights/psd3-fraud-in-the-eurozone",
    component: _6f74e943,
    name: "news/payment-insights-psd3-fraud-in-the-eurozone"
  }, {
    path: "/news/payment-insights/fraud-prevention-in-real-time-how-us-banks-can-stay-ahead-of-the-criminals",
    component: _6f74e943,
    name: "news/payment-insights-fraud-prevention-in-real-time-how-us-banks-can-stay-ahead-of-the-criminals"
  }, {
    path: "/news/payment-insights/apis-powering-payments-igniting-growth-and-pioneering-the-future-of-banking",
    component: _6f74e943,
    name: "news/payment-insights-apis-powering-payments-igniting-growth-and-pioneering-the-future-of-banking"
  }, {
    path: "/news/payment-insights/fednows-success-hinges-on-getting-enough-banks-to-connect--and-use-it",
    component: _6f74e943,
    name: "news/payment-insights-fednows-success-hinges-on-getting-enough-banks-to-connect--and-use-it"
  }, {
    path: "/news/payment-insights/report-from-cloud-to-multicloud-a-pathway-to-resilience",
    component: _6f74e943,
    name: "news/payment-insights-report-from-cloud-to-multicloud-a-pathway-to-resilience"
  }, {
    path: "/news/payment-insights/collaboration-across-industries-key-to-fraud-prevention",
    component: _6f74e943,
    name: "news/payment-insights-collaboration-across-industries-key-to-fraud-prevention"
  }, {
    path: "/news/payment-insights/what-the-us-can-learn-from-the-uk-about-push-payments-fraud",
    component: _6f74e943,
    name: "news/payment-insights-what-the-us-can-learn-from-the-uk-about-push-payments-fraud"
  }, {
    path: "/news/payment-insights/why-2025-may-not-be-enough-time-to-hit-iso-20022-transition-deadline",
    component: _6f74e943,
    name: "news/payment-insights-why-2025-may-not-be-enough-time-to-hit-iso-20022-transition-deadline"
  }, {
    path: "/news/payment-insights/batch-payments-to-become-a-long-lived-reality-in-real-time-world",
    component: _6f74e943,
    name: "news/payment-insights-batch-payments-to-become-a-long-lived-reality-in-real-time-world"
  }, {
    path: "/news/payment-insights/gated-content-rethinking-testing-strategies-for-real-time-payments",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-rethinking-testing-strategies-for-real-time-payments"
  }, {
    path: "/news/payment-insights/platforms-speed-banks-global-real-time-payments-plans",
    component: _6f74e943,
    name: "news/payment-insights-platforms-speed-banks-global-real-time-payments-plans"
  }, {
    path: "/news/payment-insights/psr-changes",
    component: _6f74e943,
    name: "news/payment-insights-psr-changes"
  }, {
    path: "/news/payment-insights/banks-look-to-the-cloud",
    component: _6f74e943,
    name: "news/payment-insights-banks-look-to-the-cloud"
  }, {
    path: "/news/payment-insights/sepa-instant-international-payments",
    component: _6f74e943,
    name: "news/payment-insights-sepa-instant-international-payments"
  }, {
    path: "/news/payment-insights/whitepaper-data-uk-faster-payments-a-model-for-us-banks",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-data-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/news/payment-insights/data-sharing-combat-financial-crime",
    component: _6f74e943,
    name: "news/payment-insights-data-sharing-combat-financial-crime"
  }, {
    path: "/news/payment-insights/gated-content-navigating-integration-and-resilience-of-new-payment-schemes",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-navigating-integration-and-resilience-of-new-payment-schemes"
  }, {
    path: "/news/payment-insights/2023-eba-sepa-maintenance-release",
    component: _6f74e943,
    name: "news/payment-insights-2023-eba-sepa-maintenance-release"
  }, {
    path: "/news/payment-insights/multi-cloud-operational-resilience",
    component: _6f74e943,
    name: "news/payment-insights-multi-cloud-operational-resilience"
  }, {
    path: "/news/payment-insights/gated-content-decoding-the-sepa-instant-mandate",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-decoding-the-sepa-instant-mandate"
  }, {
    path: "/news/payment-insights/swift-as-a-service-international-payments",
    component: _6f74e943,
    name: "news/payment-insights-swift-as-a-service-international-payments"
  }, {
    path: "/news/payment-insights/navigating-payments-transformation-for-banks",
    component: _6f74e943,
    name: "news/payment-insights-navigating-payments-transformation-for-banks"
  }, {
    path: "/news/payment-insights/whitepaper-data-sharing-to-prevent-economic-crime",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-data-sharing-to-prevent-economic-crime"
  }, {
    path: "/news/payment-insights/taking-the-stress-out-of-delivering-sepas-new-instant-payments-mandate",
    component: _6f74e943,
    name: "news/payment-insights-taking-the-stress-out-of-delivering-sepas-new-instant-payments-mandate"
  }, {
    path: "/news/payment-insights/mastering-the-fednow-service-your-guide-to-instant-payments-in-the-us",
    component: _6f74e943,
    name: "news/payment-insights-mastering-the-fednow-service-your-guide-to-instant-payments-in-the-us"
  }, {
    path: "/news/payment-insights/gated-content-why-now-for-fednow",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-why-now-for-fednow"
  }, {
    path: "/news/payment-insights/sepa-instant-payments-future-european-transactions",
    component: _6f74e943,
    name: "news/payment-insights-sepa-instant-payments-future-european-transactions"
  }, {
    path: "/news/payment-insights/uk-faster-payments-a-model-for-us-banks",
    component: _6f74e943,
    name: "news/payment-insights-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/news/payment-insights/gated-content-international-payments-build-buy-or-both",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-international-payments-build-buy-or-both"
  }, {
    path: "/news/payment-insights/cloud-optimisation-success-8-steps",
    component: _6f74e943,
    name: "news/payment-insights-cloud-optimisation-success-8-steps"
  }, {
    path: "/news/payment-insights/testing-real-time-payments",
    component: _6f74e943,
    name: "news/payment-insights-testing-real-time-payments"
  }, {
    path: "/news/payment-insights/taking-the-pain-out-of-payments-change",
    component: _6f74e943,
    name: "news/payment-insights-taking-the-pain-out-of-payments-change"
  }, {
    path: "/news/payment-insights/how-sepa-indirect-participants-benefit-dnsp",
    component: _6f74e943,
    name: "news/payment-insights-how-sepa-indirect-participants-benefit-dnsp"
  }, {
    path: "/news/payment-insights/why-now-for-fednow-use-cases-for-rtp",
    component: _6f74e943,
    name: "news/payment-insights-why-now-for-fednow-use-cases-for-rtp"
  }, {
    path: "/news/payment-insights/gated-content-real-time-payments-implementation-lessons-from-across-the-pond1",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-real-time-payments-implementation-lessons-from-across-the-pond1"
  }, {
    path: "/news/payment-insights/gated-content-how-to-combat-financial-crime-through-data-sharing-and-collaboration",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-how-to-combat-financial-crime-through-data-sharing-and-collaboration"
  }, {
    path: "/news/payment-insights/whitepaper-faster-payments-does-interoperability-matter",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-faster-payments-does-interoperability-matter"
  }, {
    path: "/news/payment-insights/big-banks-get-smart-or-smart-banks-get-big",
    component: _6f74e943,
    name: "news/payment-insights-big-banks-get-smart-or-smart-banks-get-big"
  }, {
    path: "/news/payment-insights/fednow-and-rtp-the-question-of-interoperability",
    component: _6f74e943,
    name: "news/payment-insights-fednow-and-rtp-the-question-of-interoperability"
  }, {
    path: "/news/payment-insights/gated-content-the-next-step-for-faster-payments-interoperability",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-the-next-step-for-faster-payments-interoperability"
  }, {
    path: "/news/payment-insights/fx-rates",
    component: _6f74e943,
    name: "news/payment-insights-fx-rates"
  }, {
    path: "/news/payment-insights/what-is-technical-writing",
    component: _6f74e943,
    name: "news/payment-insights-what-is-technical-writing"
  }, {
    path: "/news/payment-insights/leverage-the-power-of-international-payments",
    component: _6f74e943,
    name: "news/payment-insights-leverage-the-power-of-international-payments"
  }, {
    path: "/news/payment-insights/2023-payment-predictions-for-us-banks",
    component: _6f74e943,
    name: "news/payment-insights-2023-payment-predictions-for-us-banks"
  }, {
    path: "/news/payment-insights/confirmation-of-payee-scheme-extension-what-financial",
    component: _6f74e943,
    name: "news/payment-insights-confirmation-of-payee-scheme-extension-what-financial"
  }, {
    path: "/news/payment-insights/whitepaper-modernizing-payments-in-the-us",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-modernizing-payments-in-the-us"
  }, {
    path: "/news/payment-insights/faster-payments-and-real-time-payments",
    component: _6f74e943,
    name: "news/payment-insights-faster-payments-and-real-time-payments"
  }, {
    path: "/news/payment-insights/growing-your-international-payments-business",
    component: _6f74e943,
    name: "news/payment-insights-growing-your-international-payments-business"
  }, {
    path: "/news/payment-insights/why-banks-are-moving-to-a-platform-approach",
    component: _6f74e943,
    name: "news/payment-insights-why-banks-are-moving-to-a-platform-approach"
  }, {
    path: "/news/payment-insights/dora-cloud-regulation-for-banks-in-europe",
    component: _6f74e943,
    name: "news/payment-insights-dora-cloud-regulation-for-banks-in-europe"
  }, {
    path: "/news/payment-insights/fostering-healthy-teams-at-form3",
    component: _6f74e943,
    name: "news/payment-insights-fostering-healthy-teams-at-form3"
  }, {
    path: "/news/payment-insights/black-history-month-at-form3",
    component: _6f74e943,
    name: "news/payment-insights-black-history-month-at-form3"
  }, {
    path: "/news/payment-insights/mandated-instant-payments-whatyoushoulknow",
    component: _6f74e943,
    name: "news/payment-insights-mandated-instant-payments-whatyoushoulknow"
  }, {
    path: "/news/payment-insights/how-form3-holds-effective-meetings",
    component: _6f74e943,
    name: "news/payment-insights-how-form3-holds-effective-meetings"
  }, {
    path: "/news/payment-insights/us-payment-modernization-best-approaches-in-2022",
    component: _6f74e943,
    name: "news/payment-insights-us-payment-modernization-best-approaches-in-2022"
  }, {
    path: "/news/payment-insights/its-all-about-communication",
    component: _6f74e943,
    name: "news/payment-insights-its-all-about-communication"
  }, {
    path: "/news/payment-insights/gated-content-going-global-the-fundamentals-to-building-your-international-payments-business",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-going-global-the-fundamentals-to-building-your-international-payments-business"
  }, {
    path: "/news/payment-insights/gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention"
  }, {
    path: "/news/payment-insights/on-mental-health-as-a-manager",
    component: _6f74e943,
    name: "news/payment-insights-on-mental-health-as-a-manager"
  }, {
    path: "/news/payment-insights/psychological-safety-at-form3",
    component: _6f74e943,
    name: "news/payment-insights-psychological-safety-at-form3"
  }, {
    path: "/news/payment-insights/npa-technical-from-project-migration",
    component: _6f74e943,
    name: "news/payment-insights-npa-technical-from-project-migration"
  }, {
    path: "/news/payment-insights/how-form3-is-supporting-its-teams-mental-health",
    component: _6f74e943,
    name: "news/payment-insights-how-form3-is-supporting-its-teams-mental-health"
  }, {
    path: "/news/payment-insights/gated-content-us-payment-landscape-the-modernization-journey",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-us-payment-landscape-the-modernization-journey"
  }, {
    path: "/news/payment-insights/industry-intelligence-why-multi-cloud-is-the-future",
    component: _6f74e943,
    name: "news/payment-insights-industry-intelligence-why-multi-cloud-is-the-future"
  }, {
    path: "/news/payment-insights/industry-intelligence-how-neobanks-can-use-cross-currency",
    component: _6f74e943,
    name: "news/payment-insights-industry-intelligence-how-neobanks-can-use-cross-currency"
  }, {
    path: "/news/payment-insights/keeping-connected-in-a-remote-first-business",
    component: _6f74e943,
    name: "news/payment-insights-keeping-connected-in-a-remote-first-business"
  }, {
    path: "/news/payment-insights/case-study-nationwide-and-form3-on-migrating-payments",
    component: _6f74e943,
    name: "news/payment-insights-case-study-nationwide-and-form3-on-migrating-payments"
  }, {
    path: "/news/payment-insights/form3-cares-about-the-planet",
    component: _6f74e943,
    name: "news/payment-insights-form3-cares-about-the-planet"
  }, {
    path: "/news/payment-insights/gated-content-whitepaper-is-change-really-such-a-scary-word-digital",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-whitepaper-is-change-really-such-a-scary-word-digital"
  }, {
    path: "/news/payment-insights/gated-content-how-real-time-payments-are-solving-todays-problems-for-tomorrows-success",
    component: _6f74e943,
    name: "news/payment-insights-gated-content-how-real-time-payments-are-solving-todays-problems-for-tomorrows-success"
  }, {
    path: "/news/payment-insights/fednow-what-you-need-to-know-before-2023",
    component: _6f74e943,
    name: "news/payment-insights-fednow-what-you-need-to-know-before-2023"
  }, {
    path: "/news/payment-insights/this-is-why-we-live-in-a-golden-age-of-technology",
    component: _6f74e943,
    name: "news/payment-insights-this-is-why-we-live-in-a-golden-age-of-technology"
  }, {
    path: "/news/payment-insights/why-cloud-native-is-key-for-fintechs-in-europe",
    component: _6f74e943,
    name: "news/payment-insights-why-cloud-native-is-key-for-fintechs-in-europe"
  }, {
    path: "/news/payment-insights/fintech-regulation-in-europe-challenges-and-new-roles",
    component: _6f74e943,
    name: "news/payment-insights-fintech-regulation-in-europe-challenges-and-new-roles"
  }, {
    path: "/news/payment-insights/whitepaper-new-payments-architecture-navigating-future",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-new-payments-architecture-navigating-future"
  }, {
    path: "/news/payment-insights/webinar-are-you-ready-for-the-next-stage-in-europes",
    component: _6f74e943,
    name: "news/payment-insights-webinar-are-you-ready-for-the-next-stage-in-europes"
  }, {
    path: "/news/payment-insights/whats-top-of-mind-penny-hughes-column1",
    component: _6f74e943,
    name: "news/payment-insights-whats-top-of-mind-penny-hughes-column1"
  }, {
    path: "/news/payment-insights/industry-advice-how-devops-can-drive-technological",
    component: _6f74e943,
    name: "news/payment-insights-industry-advice-how-devops-can-drive-technological"
  }, {
    path: "/news/payment-insights/industry-advice-what-us-banks-need-to-know-about",
    component: _6f74e943,
    name: "news/payment-insights-industry-advice-what-us-banks-need-to-know-about"
  }, {
    path: "/news/payment-insights/meet-form3s-esg-intern",
    component: _6f74e943,
    name: "news/payment-insights-meet-form3s-esg-intern"
  }, {
    path: "/news/payment-insights/debunking-the-myths-of-open-source-software",
    component: _6f74e943,
    name: "news/payment-insights-debunking-the-myths-of-open-source-software"
  }, {
    path: "/news/payment-insights/setting-our-team-up-for-successful-remote-work",
    component: _6f74e943,
    name: "news/payment-insights-setting-our-team-up-for-successful-remote-work"
  }, {
    path: "/news/payment-insights/whitepaper-the-future-of-fintech-disruption-in-europe",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-the-future-of-fintech-disruption-in-europe"
  }, {
    path: "/news/payment-insights/whitepaper-how-cloud-powers-the-future-of-payments",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-how-cloud-powers-the-future-of-payments"
  }, {
    path: "/news/payment-insights/our-culture-of-continuous-learning",
    component: _6f74e943,
    name: "news/payment-insights-our-culture-of-continuous-learning"
  }, {
    path: "/news/payment-insights/whitepaper-born-in-the-cloud",
    component: _6f74e943,
    name: "news/payment-insights-whitepaper-born-in-the-cloud"
  }, {
    path: "/news/payment-insights/instant-payments-in-europe",
    component: _6f74e943,
    name: "news/payment-insights-instant-payments-in-europe"
  }, {
    path: "/news/payment-insights/form3s-approach-to-giving-back",
    component: _6f74e943,
    name: "news/payment-insights-form3s-approach-to-giving-back"
  }, {
    path: "/news/payment-insights/npa-webinar",
    component: _6f74e943,
    name: "news/payment-insights-npa-webinar"
  }, {
    path: "/news/payment-insights/whats-top-of-mind-penny-hughes-column",
    component: _6f74e943,
    name: "news/payment-insights-whats-top-of-mind-penny-hughes-column"
  }, {
    path: "/news/payment-insights/industry-advice-how-to-plan-for-the-new-payments-architecture",
    component: _6f74e943,
    name: "news/payment-insights-industry-advice-how-to-plan-for-the-new-payments-architecture"
  }, {
    path: "/news/payment-insights/international-womens-day-spotlight-the-life-of-a-technology-evangelist",
    component: _6f74e943,
    name: "news/payment-insights-international-womens-day-spotlight-the-life-of-a-technology-evangelist"
  }, {
    path: "/news/payment-insights/male-allies-at-form3-on-international-womens-day",
    component: _6f74e943,
    name: "news/payment-insights-male-allies-at-form3-on-international-womens-day"
  }, {
    path: "/news/payment-insights/asynchronous-communication-at-form3",
    component: _6f74e943,
    name: "news/payment-insights-asynchronous-communication-at-form3"
  }, {
    path: "/news/payment-insights/form3-diversity-update---a-year-in-review",
    component: _6f74e943,
    name: "news/payment-insights-form3-diversity-update---a-year-in-review"
  }, {
    path: "/news/payment-insights/form3s-first-apprentice",
    component: _6f74e943,
    name: "news/payment-insights-form3s-first-apprentice"
  }, {
    path: "/news/payment-insights/lessons-learned-from-europe",
    component: _6f74e943,
    name: "news/payment-insights-lessons-learned-from-europe"
  }, {
    path: "/news/payment-insights/you-may-be-iso-to-the-core-but-the-form3-platform-is-still-your-best-gateway-option",
    component: _6f74e943,
    name: "news/payment-insights-you-may-be-iso-to-the-core-but-the-form3-platform-is-still-your-best-gateway-option"
  }, {
    path: "/news/payment-insights/how-microservices-are-changing-the-game-for-operational-resilience-and-cyber-security-in-payments",
    component: _6f74e943,
    name: "news/payment-insights-how-microservices-are-changing-the-game-for-operational-resilience-and-cyber-security-in-payments"
  }, {
    path: "/news/payment-insights/why-cloud-payment-processing-is-the-answer-to-scaling-challenges-at-banks",
    component: _6f74e943,
    name: "news/payment-insights-why-cloud-payment-processing-is-the-answer-to-scaling-challenges-at-banks"
  }, {
    path: "/news/payment-insights/why-enterprise-banks-must-adopt-innovations-in-payment-technologies",
    component: _6f74e943,
    name: "news/payment-insights-why-enterprise-banks-must-adopt-innovations-in-payment-technologies"
  }, {
    path: "/news/payment-insights/why-corporate-treasurers-should-care-about-the-tech-their-banks-are-using",
    component: _6f74e943,
    name: "news/payment-insights-why-corporate-treasurers-should-care-about-the-tech-their-banks-are-using"
  }, {
    path: "/news/payment-insights/confirmation-of-payee-opportunity-or-headache",
    component: _6f74e943,
    name: "news/payment-insights-confirmation-of-payee-opportunity-or-headache"
  }, {
    path: "/news/payment-insights/minimising-the-risk-of-transforming-core-payments-technology---a-form3-perspective",
    component: _6f74e943,
    name: "news/payment-insights-minimising-the-risk-of-transforming-core-payments-technology---a-form3-perspective"
  }, {
    path: "/news/payment-insights/the-key-to-open-bankings-success-global-adoption-of-real-time-payments",
    component: _6f74e943,
    name: "news/payment-insights-the-key-to-open-bankings-success-global-adoption-of-real-time-payments"
  }, {
    path: "/news/payment-insights/female-leadership-spotlight--penny-hughes",
    component: _6f74e943,
    name: "news/payment-insights-female-leadership-spotlight--penny-hughes"
  }, {
    path: "/news/payment-insights/female-leadership-spotlight---eimear-oconnor",
    component: _6f74e943,
    name: "news/payment-insights-female-leadership-spotlight---eimear-oconnor"
  }, {
    path: "/news/payment-insights/your-guide-to-selecting-the-right-payments-technology-partner",
    component: _6f74e943,
    name: "news/payment-insights-your-guide-to-selecting-the-right-payments-technology-partner"
  }, {
    path: "/news/payment-insights/female-leadership-spotlight---bonnie-mitchell",
    component: _6f74e943,
    name: "news/payment-insights-female-leadership-spotlight---bonnie-mitchell"
  }, {
    path: "/news/payment-insights/how-to-effectively-run-payment-transformation-programmes-with-banks-in-a-fully-remote-environment",
    component: _6f74e943,
    name: "news/payment-insights-how-to-effectively-run-payment-transformation-programmes-with-banks-in-a-fully-remote-environment"
  }, {
    path: "/news/payment-insights/why-financial-institutions-are-banking-on-cloud-native-technology-to-stay-competitive",
    component: _6f74e943,
    name: "news/payment-insights-why-financial-institutions-are-banking-on-cloud-native-technology-to-stay-competitive"
  }, {
    path: "/news/payment-insights/utilising-pair-programming-in-a-100-remote-environment",
    component: _6f74e943,
    name: "news/payment-insights-utilising-pair-programming-in-a-100-remote-environment"
  }, {
    path: "/news/payment-insights/managing-and-leading-transformational-change-projects-at-a-fast-growing-fintech",
    component: _6f74e943,
    name: "news/payment-insights-managing-and-leading-transformational-change-projects-at-a-fast-growing-fintech"
  }, {
    path: "/news/payment-insights/what-the-hack",
    component: _6f74e943,
    name: "news/payment-insights-what-the-hack"
  }, {
    path: "/news/payment-insights/accelerating-innovation-in-financial-services",
    component: _6f74e943,
    name: "news/payment-insights-accelerating-innovation-in-financial-services"
  }, {
    path: "/news/payment-insights/international-womens-day",
    component: _6f74e943,
    name: "news/payment-insights-international-womens-day"
  }, {
    path: "/news/payment-insights/a-remote-first-culture",
    component: _6f74e943,
    name: "news/payment-insights-a-remote-first-culture"
  }, {
    path: "/news/payment-insights/building-connections",
    component: _6f74e943,
    name: "news/payment-insights-building-connections"
  }, {
    path: "/news/payment-insights/raising-our-standards",
    component: _6f74e943,
    name: "news/payment-insights-raising-our-standards"
  }, {
    path: "/news/payment-insights/bridging-the-divide",
    component: _6f74e943,
    name: "news/payment-insights-bridging-the-divide"
  }, {
    path: "/news/payment-insights/back-to-the-future",
    component: _6f74e943,
    name: "news/payment-insights-back-to-the-future"
  }, {
    path: "/news/payment-insights/the-great-divide",
    component: _6f74e943,
    name: "news/payment-insights-the-great-divide"
  }, {
    path: "/news/payment-insights/payments-dna",
    component: _6f74e943,
    name: "news/payment-insights-payments-dna"
  }, {
    path: "/news/payment-insights/game-changers",
    component: _6f74e943,
    name: "news/payment-insights-game-changers"
  }, {
    path: "/news/payment-insights/nowhere-to-hide",
    component: _6f74e943,
    name: "news/payment-insights-nowhere-to-hide"
  }, {
    path: "/news/payment-insights/standards--old-problems-new-solutions",
    component: _6f74e943,
    name: "news/payment-insights-standards--old-problems-new-solutions"
  }, {
    path: "/news/payment-insights/new-payments-architecture",
    component: _6f74e943,
    name: "news/payment-insights-new-payments-architecture"
  }, {
    path: "/news/payment-insights/hyper-automation-in-payments",
    component: _6f74e943,
    name: "news/payment-insights-hyper-automation-in-payments"
  }, {
    path: "/news/payment-insights/women-in-tech",
    component: _6f74e943,
    name: "news/payment-insights-women-in-tech"
  }, {
    path: "/news/payment-insights/real-time-is-becoming-the-new-normal-in-payments",
    component: _6f74e943,
    name: "news/payment-insights-real-time-is-becoming-the-new-normal-in-payments"
  }, {
    path: "/news/payment-insights/will-all-banks-and-psps-require-their-own-sort-code-from-july-2019",
    component: _6f74e943,
    name: "news/payment-insights-will-all-banks-and-psps-require-their-own-sort-code-from-july-2019"
  }, {
    path: "/blog/engineering/dangling-danger",
    component: _52c85e91,
    name: "blog/engineering-dangling-danger"
  }, {
    path: "/blog/engineering/five-ws-incident-mngmnt",
    component: _52c85e91,
    name: "blog/engineering-five-ws-incident-mngmnt"
  }, {
    path: "/blog/engineering/podcast-conf-speaking",
    component: _52c85e91,
    name: "blog/engineering-podcast-conf-speaking"
  }, {
    path: "/blog/engineering/blog-decision-making",
    component: _52c85e91,
    name: "blog/engineering-blog-decision-making"
  }, {
    path: "/blog/engineering/incident-mngmnt-devops",
    component: _52c85e91,
    name: "blog/engineering-incident-mngmnt-devops"
  }, {
    path: "/blog/engineering/podcast-whats-new-nats",
    component: _52c85e91,
    name: "blog/engineering-podcast-whats-new-nats"
  }, {
    path: "/blog/engineering/customers-incidents-prometheus",
    component: _52c85e91,
    name: "blog/engineering-customers-incidents-prometheus"
  }, {
    path: "/blog/engineering/podcast-containers",
    component: _52c85e91,
    name: "blog/engineering-podcast-containers"
  }, {
    path: "/blog/engineering/packets-aws-gateway-load",
    component: _52c85e91,
    name: "blog/engineering-packets-aws-gateway-load"
  }, {
    path: "/blog/engineering/secrets-build-pipelines",
    component: _52c85e91,
    name: "blog/engineering-secrets-build-pipelines"
  }, {
    path: "/blog/engineering/podcast-ext-secrets",
    component: _52c85e91,
    name: "blog/engineering-podcast-ext-secrets"
  }, {
    path: "/blog/engineering/life-of-incident-mngr",
    component: _52c85e91,
    name: "blog/engineering-life-of-incident-mngr"
  }, {
    path: "/blog/engineering/blog-bootstrapping-engineering-org",
    component: _52c85e91,
    name: "blog/engineering-blog-bootstrapping-engineering-org"
  }, {
    path: "/blog/engineering/podcast-idp",
    component: _52c85e91,
    name: "blog/engineering-podcast-idp"
  }, {
    path: "/blog/engineering/intro-ethical-hacking",
    component: _52c85e91,
    name: "blog/engineering-intro-ethical-hacking"
  }, {
    path: "/blog/engineering/migrating-gh-boards",
    component: _52c85e91,
    name: "blog/engineering-migrating-gh-boards"
  }, {
    path: "/blog/engineering/podcast-landing-remote-job",
    component: _52c85e91,
    name: "blog/engineering-podcast-landing-remote-job"
  }, {
    path: "/blog/engineering/phishing-github",
    component: _52c85e91,
    name: "blog/engineering-phishing-github"
  }, {
    path: "/blog/engineering/first-month-swe",
    component: _52c85e91,
    name: "blog/engineering-first-month-swe"
  }, {
    path: "/blog/engineering/podcast-async-reviews",
    component: _52c85e91,
    name: "blog/engineering-podcast-async-reviews"
  }, {
    path: "/blog/engineering/electron-injection",
    component: _52c85e91,
    name: "blog/engineering-electron-injection"
  }, {
    path: "/blog/engineering/podcast-build-multicloud",
    component: _52c85e91,
    name: "blog/engineering-podcast-build-multicloud"
  }, {
    path: "/blog/engineering/starting-new-project",
    component: _52c85e91,
    name: "blog/engineering-starting-new-project"
  }, {
    path: "/blog/engineering/how-to-find-and-fix-memory-leaks-in-go-applications",
    component: _52c85e91,
    name: "blog/engineering-how-to-find-and-fix-memory-leaks-in-go-applications"
  }, {
    path: "/blog/engineering/podcast-remote-work",
    component: _52c85e91,
    name: "blog/engineering-podcast-remote-work"
  }, {
    path: "/blog/engineering/nacls-blogpost",
    component: _52c85e91,
    name: "blog/engineering-nacls-blogpost"
  }, {
    path: "/blog/engineering/buckle-up-your-mtls-with-oauth-2-0-client-authentication",
    component: _52c85e91,
    name: "blog/engineering-buckle-up-your-mtls-with-oauth-2-0-client-authentication"
  }, {
    path: "/blog/engineering/exploiting-distroless-images",
    component: _52c85e91,
    name: "blog/engineering-exploiting-distroless-images"
  }, {
    path: "/blog/engineering/podcast-k8s-robusta",
    component: _52c85e91,
    name: "blog/engineering-podcast-k8s-robusta"
  }, {
    path: "/blog/engineering/podcast-engineering-success",
    component: _52c85e91,
    name: "blog/engineering-podcast-engineering-success"
  }, {
    path: "/blog/engineering/pki-cert-management",
    component: _52c85e91,
    name: "blog/engineering-pki-cert-management"
  }, {
    path: "/blog/engineering/podcast-supporting-diversity",
    component: _52c85e91,
    name: "blog/engineering-podcast-supporting-diversity"
  }, {
    path: "/blog/engineering/dylib-injection-in-golang-apps",
    component: _52c85e91,
    name: "blog/engineering-dylib-injection-in-golang-apps"
  }, {
    path: "/blog/engineering/linux-fundamentals-user-kernel-space",
    component: _52c85e91,
    name: "blog/engineering-linux-fundamentals-user-kernel-space"
  }, {
    path: "/blog/engineering/podcast-evolving-apis",
    component: _52c85e91,
    name: "blog/engineering-podcast-evolving-apis"
  }, {
    path: "/blog/engineering/bypassing-ebpf-tools",
    component: _52c85e91,
    name: "blog/engineering-bypassing-ebpf-tools"
  }, {
    path: "/blog/engineering/podcast-careers-engineering",
    component: _52c85e91,
    name: "blog/engineering-podcast-careers-engineering"
  }, {
    path: "/blog/engineering/testing-at-form3",
    component: _52c85e91,
    name: "blog/engineering-testing-at-form3"
  }, {
    path: "/blog/engineering/nat-and-proxies-part2",
    component: _52c85e91,
    name: "blog/engineering-nat-and-proxies-part2"
  }, {
    path: "/blog/engineering/nat-and-proxies-part-1",
    component: _52c85e91,
    name: "blog/engineering-nat-and-proxies-part-1"
  }, {
    path: "/blog/engineering/security-scanning-using-tfsec",
    component: _52c85e91,
    name: "blog/engineering-security-scanning-using-tfsec"
  }, {
    path: "/blog/engineering/running-elk-locally-to-interrogate-container-logs",
    component: _52c85e91,
    name: "blog/engineering-running-elk-locally-to-interrogate-container-logs"
  }, {
    path: "/blog/engineering/infrastructure-as-code-to-control-access-to-everything",
    component: _52c85e91,
    name: "blog/engineering-infrastructure-as-code-to-control-access-to-everything"
  }, {
    path: "/blog/engineering/conf42-golang-2022-load-testing-with-f1",
    component: _52c85e91,
    name: "blog/engineering-conf42-golang-2022-load-testing-with-f1"
  }, {
    path: "/blog/engineering/delivering-at-scale-for-meta",
    component: _52c85e91,
    name: "blog/engineering-delivering-at-scale-for-meta"
  }, {
    path: "/blog/engineering/ep27-podcast",
    component: _52c85e91,
    name: "blog/engineering-ep27-podcast"
  }, {
    path: "/blog/engineering/prometheus-histograms",
    component: _52c85e91,
    name: "blog/engineering-prometheus-histograms"
  }, {
    path: "/blog/engineering/ep26-podcast",
    component: _52c85e91,
    name: "blog/engineering-ep26-podcast"
  }, {
    path: "/blog/engineering/ep25-podcast",
    component: _52c85e91,
    name: "blog/engineering-ep25-podcast"
  }, {
    path: "/blog/engineering/ep24-podcast",
    component: _52c85e91,
    name: "blog/engineering-ep24-podcast"
  }, {
    path: "/blog/engineering/ep23-podcast",
    component: _52c85e91,
    name: "blog/engineering-ep23-podcast"
  }, {
    path: "/blog/engineering/millions-payments-haproxy",
    component: _52c85e91,
    name: "blog/engineering-millions-payments-haproxy"
  }, {
    path: "/blog/engineering/ep22-podcast",
    component: _52c85e91,
    name: "blog/engineering-ep22-podcast"
  }, {
    path: "/blog/engineering/conf42-code-insight",
    component: _52c85e91,
    name: "blog/engineering-conf42-code-insight"
  }, {
    path: "/blog/engineering/gophercon-elastic",
    component: _52c85e91,
    name: "blog/engineering-gophercon-elastic"
  }, {
    path: "/blog/engineering/gophercon-nats",
    component: _52c85e91,
    name: "blog/engineering-gophercon-nats"
  }, {
    path: "/blog/engineering/remote-pair-programming",
    component: _52c85e91,
    name: "blog/engineering-remote-pair-programming"
  }, {
    path: "/engineering/who-we-are/open-source",
    component: _7ab26e2a,
    name: "engineering/who-we-are-open-source"
  }, {
    path: "/engineering/who-we-are/tech-stack",
    component: _7ab26e2a,
    name: "engineering/who-we-are-tech-stack"
  }, {
    path: "/campaigns/first-campaign-post",
    component: _38407230,
    name: "campaigns-first-campaign-post"
  }, {
    path: "/campaigns/npa-webinar-1",
    component: _38407230,
    name: "campaigns-npa-webinar-1"
  }, {
    path: "/campaigns/re-platforming-critical-payments-infrastructure-to",
    component: _38407230,
    name: "campaigns-re-platforming-critical-payments-infrastructure-to"
  }, {
    path: "/campaigns/instant-payments-in-europe-where-next",
    component: _38407230,
    name: "campaigns-instant-payments-in-europe-where-next"
  }, {
    path: "/campaigns/the-future-of-fintech-disruption-in-europe",
    component: _38407230,
    name: "campaigns-the-future-of-fintech-disruption-in-europe"
  }, {
    path: "/campaigns/download-how-cloud-powers-the-future-of-payments",
    component: _38407230,
    name: "campaigns-download-how-cloud-powers-the-future-of-payments"
  }, {
    path: "/campaigns/european-payment-evolution-22",
    component: _38407230,
    name: "campaigns-european-payment-evolution-22"
  }, {
    path: "/campaigns/new-payments-architecture-navigating-future-access",
    component: _38407230,
    name: "campaigns-new-payments-architecture-navigating-future-access"
  }, {
    path: "/campaigns/is-change-really-such-a-scary-word-digital-disruption",
    component: _38407230,
    name: "campaigns-is-change-really-such-a-scary-word-digital-disruption"
  }, {
    path: "/campaigns/gated-content-tomorrows-problems-for-todays-success",
    component: _38407230,
    name: "campaigns-gated-content-tomorrows-problems-for-todays-success"
  }, {
    path: "/campaigns/gated-content-us-payment-landscape-the-modernization-journey",
    component: _38407230,
    name: "campaigns-gated-content-us-payment-landscape-the-modernization-journey"
  }, {
    path: "/campaigns/gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention",
    component: _38407230,
    name: "campaigns-gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention"
  }, {
    path: "/campaigns/gated-content-going-global-the-fundamentals-to-building-your-international-payments-business",
    component: _38407230,
    name: "campaigns-gated-content-going-global-the-fundamentals-to-building-your-international-payments-business"
  }, {
    path: "/campaigns/gated-content-international-services-webinar",
    component: _38407230,
    name: "campaigns-gated-content-international-services-webinar"
  }, {
    path: "/campaigns/gated-content-sepa-services-webinar2",
    component: _38407230,
    name: "campaigns-gated-content-sepa-services-webinar2"
  }, {
    path: "/campaigns/gated-content-uk-payments-services",
    component: _38407230,
    name: "campaigns-gated-content-uk-payments-services"
  }, {
    path: "/campaigns/gated-content-modernizing-payments-in-the-us",
    component: _38407230,
    name: "campaigns-gated-content-modernizing-payments-in-the-us"
  }, {
    path: "/campaigns/partners-multicloud-webinar",
    component: _38407230,
    name: "campaigns-partners-multicloud-webinar"
  }, {
    path: "/campaigns/partners-us-payments-services-webinar",
    component: _38407230,
    name: "campaigns-partners-us-payments-services-webinar"
  }, {
    path: "/campaigns/gated-content-video-the-next-step-for-faster-payments-interoperability",
    component: _38407230,
    name: "campaigns-gated-content-video-the-next-step-for-faster-payments-interoperability"
  }, {
    path: "/campaigns/gated-content-sepa-instant-factsheet",
    component: _38407230,
    name: "campaigns-gated-content-sepa-instant-factsheet"
  }, {
    path: "/campaigns/gated-content-instant-has-been-mandated-will-you-be-ready-for-it",
    component: _38407230,
    name: "campaigns-gated-content-instant-has-been-mandated-will-you-be-ready-for-it"
  }, {
    path: "/campaigns/gated-content-faster-payments-does-interoperability-matter",
    component: _38407230,
    name: "campaigns-gated-content-faster-payments-does-interoperability-matter"
  }, {
    path: "/campaigns/gated-content-video-the-next-step-for-faster-payments-interoperability1",
    component: _38407230,
    name: "campaigns-gated-content-video-the-next-step-for-faster-payments-interoperability1"
  }, {
    path: "/campaigns/gated-content-meeting-the-challenges-of-the-uks-new-payment-architecture",
    component: _38407230,
    name: "campaigns-gated-content-meeting-the-challenges-of-the-uks-new-payment-architecture"
  }, {
    path: "/campaigns/gated-content-video-international-payments-build-buy-or-both",
    component: _38407230,
    name: "campaigns-gated-content-video-international-payments-build-buy-or-both"
  }, {
    path: "/campaigns/gated-content-video-why-now-for-fednow",
    component: _38407230,
    name: "campaigns-gated-content-video-why-now-for-fednow"
  }, {
    path: "/campaigns/comprehensive-guide-to-new-payments-architecture",
    component: _38407230,
    name: "campaigns-comprehensive-guide-to-new-payments-architecture"
  }, {
    path: "/campaigns/gated-content-data-sharing-to-prevent-economic-crime",
    component: _38407230,
    name: "campaigns-gated-content-data-sharing-to-prevent-economic-crime"
  }, {
    path: "/campaigns/gated-content-video-decoding-the-sepa-instant-mandate",
    component: _38407230,
    name: "campaigns-gated-content-video-decoding-the-sepa-instant-mandate"
  }, {
    path: "/campaigns/gated-content-leading-european-psp-achieve-rapid-expansion",
    component: _38407230,
    name: "campaigns-gated-content-leading-european-psp-achieve-rapid-expansion"
  }, {
    path: "/campaigns/gated-content-video-navigating-integration-and-resilience-of-new-payment-schemes",
    component: _38407230,
    name: "campaigns-gated-content-video-navigating-integration-and-resilience-of-new-payment-schemes"
  }, {
    path: "/campaigns/gated-content-uk-faster-payments-a-model-for-us-banks",
    component: _38407230,
    name: "campaigns-gated-content-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/campaigns/gated-content-video-rethinking-testing-strategies-for-real-time-payments",
    component: _38407230,
    name: "campaigns-gated-content-video-rethinking-testing-strategies-for-real-time-payments"
  }, {
    path: "/campaigns/gated-content-from-cloud-to-multicloud-a-pathway-to-resilience",
    component: _38407230,
    name: "campaigns-gated-content-from-cloud-to-multicloud-a-pathway-to-resilience"
  }, {
    path: "/campaigns/gated-content-video-how-apis-are-reshaping-the-payments-landscape",
    component: _38407230,
    name: "campaigns-gated-content-video-how-apis-are-reshaping-the-payments-landscape"
  }, {
    path: "/campaigns/gated-content-video-interoperability-global-instant-schemes",
    component: _38407230,
    name: "campaigns-gated-content-video-interoperability-global-instant-schemes"
  }, {
    path: "/campaigns/gated-content-advancing-payment-innovation",
    component: _38407230,
    name: "campaigns-gated-content-advancing-payment-innovation"
  }, {
    path: "/campaigns/gated-content-video-unleash-the-power-of-iso-20022",
    component: _38407230,
    name: "campaigns-gated-content-video-unleash-the-power-of-iso-20022"
  }, {
    path: "/campaigns/gated-content-video-demystifying-payment-modernization-separating-fact-from-fiction",
    component: _38407230,
    name: "campaigns-gated-content-video-demystifying-payment-modernization-separating-fact-from-fiction"
  }, {
    path: "/campaigns/gated-content-video-webinar-pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards",
    component: _38407230,
    name: "campaigns-gated-content-video-webinar-pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards"
  }, {
    path: "/campaigns/navigating-the-digital-shift-download-2",
    component: _38407230,
    name: "campaigns-navigating-the-digital-shift-download-2"
  }, {
    path: "/campaigns/navigating-the-digital-shift-download-3",
    component: _38407230,
    name: "campaigns-navigating-the-digital-shift-download-3"
  }, {
    path: "/campaigns/download-navigating-the-digital-shift-final",
    component: _38407230,
    name: "campaigns-download-navigating-the-digital-shift-final"
  }, {
    path: "/campaigns/rethinking-a-platform-approach-to-payments",
    component: _38407230,
    name: "campaigns-rethinking-a-platform-approach-to-payments"
  }, {
    path: "/campaigns/gated-content-video-real-time-payments-implementation-lessons-from-across-the-pond",
    component: _38407230,
    name: "campaigns-gated-content-video-real-time-payments-implementation-lessons-from-across-the-pond"
  }, {
    path: "/campaigns/why-orchestration-is-key-for-payment-modernization",
    component: _38407230,
    name: "campaigns-why-orchestration-is-key-for-payment-modernization"
  }, {
    path: "/campaigns/why-orchestration-is-key-for-payment-modernization-download",
    component: _38407230,
    name: "campaigns-why-orchestration-is-key-for-payment-modernization-download"
  }, {
    path: "/campaigns/download-navigating-the-fedwire-migration-to-iso-20022",
    component: _38407230,
    name: "campaigns-download-navigating-the-fedwire-migration-to-iso-20022"
  }, {
    path: "/campaigns/datos-download",
    component: _38407230,
    name: "campaigns-datos-download"
  }, {
    path: "/campaigns/nationwide-and-form3",
    component: _38407230,
    name: "campaigns-nationwide-and-form3"
  }, {
    path: "/campaigns/harnessing-instant-payments-in-the-us-with-the-rtp-network",
    component: _38407230,
    name: "campaigns-harnessing-instant-payments-in-the-us-with-the-rtp-network"
  }, {
    path: "/landing/test-landing-post",
    component: _459eabdc,
    name: "landing-test-landing-post"
  }, {
    path: "/landing/whitepaper-born-in-the-cloud",
    component: _459eabdc,
    name: "landing-whitepaper-born-in-the-cloud"
  }, {
    path: "/landing/whitepaper-instant-payments-in-europe-where-next",
    component: _459eabdc,
    name: "landing-whitepaper-instant-payments-in-europe-where-next"
  }, {
    path: "/landing/download-the-whitepaper-the-future-of-fintech-disruption",
    component: _459eabdc,
    name: "landing-download-the-whitepaper-the-future-of-fintech-disruption"
  }, {
    path: "/landing/whitepaper-how-cloud-powers-the-future-of-payments",
    component: _459eabdc,
    name: "landing-whitepaper-how-cloud-powers-the-future-of-payments"
  }, {
    path: "/landing/download-the-whitepaper-new-payments-architecture-navigating-future-access-models",
    component: _459eabdc,
    name: "landing-download-the-whitepaper-new-payments-architecture-navigating-future-access-models"
  }, {
    path: "/landing/download-the-whitepaper-is-change-really-such-a-scary",
    component: _459eabdc,
    name: "landing-download-the-whitepaper-is-change-really-such-a-scary"
  }, {
    path: "/landing/gated-content-download-the-whitepaper-todays-problems-for-tomorrows-success",
    component: _459eabdc,
    name: "landing-gated-content-download-the-whitepaper-todays-problems-for-tomorrows-success"
  }, {
    path: "/landing/gated-content-download-the-whitepaper-meeting-the-challenges-of-the-uks-new-payment-architecture",
    component: _459eabdc,
    name: "landing-gated-content-download-the-whitepaper-meeting-the-challenges-of-the-uks-new-payment-architecture"
  }, {
    path: "/landing/women-who-go-london",
    component: _459eabdc,
    name: "landing-women-who-go-london"
  }, {
    path: "/landing/gated-content-download-the-webinar-us-payment-landscape-the-modernization-journey",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-us-payment-landscape-the-modernization-journey"
  }, {
    path: "/landing/whats-top-of-mind-penny-hughes-column",
    component: _459eabdc,
    name: "landing-whats-top-of-mind-penny-hughes-column"
  }, {
    path: "/landing/gated-content-download-the-webinar-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention"
  }, {
    path: "/landing/gated-content-download-the-webinar-going-global-the-fundamentals-to-building-your-international-payments-business",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-going-global-the-fundamentals-to-building-your-international-payments-business"
  }, {
    path: "/landing/payment-platform-us-us-instant-instant101",
    component: _459eabdc,
    name: "landing-payment-platform-us-us-instant-instant101"
  }, {
    path: "/landing/gated-content-download-the-webinar-modernizing-payments-in-the-us",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-modernizing-payments-in-the-us"
  }, {
    path: "/landing/delivering-payments-innovation-and-efficiency-during-challenging-times",
    component: _459eabdc,
    name: "landing-delivering-payments-innovation-and-efficiency-during-challenging-times"
  }, {
    path: "/landing/looking-back-at-2022-looking-forward-to-2023",
    component: _459eabdc,
    name: "landing-looking-back-at-2022-looking-forward-to-2023"
  }, {
    path: "/landing/payment-platform-us-us-wires101",
    component: _459eabdc,
    name: "landing-payment-platform-us-us-wires101"
  }, {
    path: "/landing/gated-content-download-the-webinar-the-next-step-for-faster-payments-interoperability",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-the-next-step-for-faster-payments-interoperability"
  }, {
    path: "/landing/gated-content-download-the-factsheet-instant-has-been-mandated-will-you-be-ready-for-it",
    component: _459eabdc,
    name: "landing-gated-content-download-the-factsheet-instant-has-been-mandated-will-you-be-ready-for-it"
  }, {
    path: "/landing/form3-insights-series",
    component: _459eabdc,
    name: "landing-form3-insights-series"
  }, {
    path: "/landing/gated-content-download-the-whitepaper-faster-payments-does-interoperability-matter",
    component: _459eabdc,
    name: "landing-gated-content-download-the-whitepaper-faster-payments-does-interoperability-matter"
  }, {
    path: "/landing/gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration"
  }, {
    path: "/landing/gated-content-download-the-webinar-international-payments-build-buy-or-both",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-international-payments-build-buy-or-both"
  }, {
    path: "/landing/economic-crime-congress",
    component: _459eabdc,
    name: "landing-economic-crime-congress"
  }, {
    path: "/landing/gated-content-download-the-webinar-why-now-for-fednow",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-why-now-for-fednow"
  }, {
    path: "/landing/why-our-people-are-driving-form3s-success",
    component: _459eabdc,
    name: "landing-why-our-people-are-driving-form3s-success"
  }, {
    path: "/landing/preparing-for-market-changes-across-the-payments-landscape",
    component: _459eabdc,
    name: "landing-preparing-for-market-changes-across-the-payments-landscape"
  }, {
    path: "/landing/gated-content-download-the-whitepaper-data-sharing-to-prevent-economic-crime",
    component: _459eabdc,
    name: "landing-gated-content-download-the-whitepaper-data-sharing-to-prevent-economic-crime"
  }, {
    path: "/landing/baft-2023",
    component: _459eabdc,
    name: "landing-baft-2023"
  }, {
    path: "/landing/gated-content-download-the-webinar-decoding-the-sepa-instant-mandate",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-decoding-the-sepa-instant-mandate"
  }, {
    path: "/landing/gated-content-download-the-webinar-navigating-integration-and-resilience-of-new-payment-schemes",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-navigating-integration-and-resilience-of-new-payment-schemes"
  }, {
    path: "/landing/gated-content-download-the-whitepaper-uk-faster-payments-a-model-for-us-banks",
    component: _459eabdc,
    name: "landing-gated-content-download-the-whitepaper-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/landing/gated-content-download-the-case-study",
    component: _459eabdc,
    name: "landing-gated-content-download-the-case-study"
  }, {
    path: "/landing/gated-content-download-the-linkedlnlive-rethinking-testing-strategies-for-real-time-payments",
    component: _459eabdc,
    name: "landing-gated-content-download-the-linkedlnlive-rethinking-testing-strategies-for-real-time-payments"
  }, {
    path: "/landing/gated-content-download-the-report-from-cloud-to-multicloud-a-pathway-to-resilience",
    component: _459eabdc,
    name: "landing-gated-content-download-the-report-from-cloud-to-multicloud-a-pathway-to-resilience"
  }, {
    path: "/landing/partnerships-key-to-modernising-payments-infrastructure",
    component: _459eabdc,
    name: "landing-partnerships-key-to-modernising-payments-infrastructure"
  }, {
    path: "/landing/sandbox-testing-for-rtp-and-fednow-in-2023",
    component: _459eabdc,
    name: "landing-sandbox-testing-for-rtp-and-fednow-in-2023"
  }, {
    path: "/landing/gated-content-download-the-webinar-how-apis-are-reshaping-the-payments-landscape",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-how-apis-are-reshaping-the-payments-landscape"
  }, {
    path: "/landing/gated-content-download-the-livestream-interoperability",
    component: _459eabdc,
    name: "landing-gated-content-download-the-livestream-interoperability"
  }, {
    path: "/landing/why-we-are-setting-a-new-standard1",
    component: _459eabdc,
    name: "landing-why-we-are-setting-a-new-standard1"
  }, {
    path: "/landing/gated-content-download-the-whitepaper-advancing-payment-innovation",
    component: _459eabdc,
    name: "landing-gated-content-download-the-whitepaper-advancing-payment-innovation"
  }, {
    path: "/landing/why-we-are-setting-a-new-standard",
    component: _459eabdc,
    name: "landing-why-we-are-setting-a-new-standard"
  }, {
    path: "/landing/transform-your-payments-landscape",
    component: _459eabdc,
    name: "landing-transform-your-payments-landscape"
  }, {
    path: "/landing/multicloud-for-payment-resilience",
    component: _459eabdc,
    name: "landing-multicloud-for-payment-resilience"
  }, {
    path: "/landing/payment-platforms-power-innovation",
    component: _459eabdc,
    name: "landing-payment-platforms-power-innovation"
  }, {
    path: "/landing/sibos-2023-fednow-takes-centre-stage",
    component: _459eabdc,
    name: "landing-sibos-2023-fednow-takes-centre-stage"
  }, {
    path: "/landing/form3-operations-big-progress-a-major-partnership-new-leadership",
    component: _459eabdc,
    name: "landing-form3-operations-big-progress-a-major-partnership-new-leadership"
  }, {
    path: "/landing/gated-content-download-the-webinar-unleash-the-power-of-iso-20022",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-unleash-the-power-of-iso-20022"
  }, {
    path: "/landing/question-and-answer-unleash-the-power-of-iso-20022",
    component: _459eabdc,
    name: "landing-question-and-answer-unleash-the-power-of-iso-20022"
  }, {
    path: "/landing/contact-blog",
    component: _459eabdc,
    name: "landing-contact-blog"
  }, {
    path: "/landing/how-form3s-positive-progress-in-2023-will-continue-this-year",
    component: _459eabdc,
    name: "landing-how-form3s-positive-progress-in-2023-will-continue-this-year"
  }, {
    path: "/landing/what-are-the-key-trends-in-payments-in-2024",
    component: _459eabdc,
    name: "landing-what-are-the-key-trends-in-payments-in-2024"
  }, {
    path: "/landing/gated-content-download-the-webinar-demystifying-payment-modernization-separating-fact-from-fiction",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-demystifying-payment-modernization-separating-fact-from-fiction"
  }, {
    path: "/landing/gated-content-download-the-webinar-pymnts-taking-a-proactive-approach-to-instant-payments-risks-and-rewards",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-pymnts-taking-a-proactive-approach-to-instant-payments-risks-and-rewards"
  }, {
    path: "/landing/gated-content-download-the-whitepaper-navigating-the-digital-shift",
    component: _459eabdc,
    name: "landing-gated-content-download-the-whitepaper-navigating-the-digital-shift"
  }, {
    path: "/landing/navigating-the-digital-shift-form-2",
    component: _459eabdc,
    name: "landing-navigating-the-digital-shift-form-2"
  }, {
    path: "/landing/navigating-the-digital-shift-form-3",
    component: _459eabdc,
    name: "landing-navigating-the-digital-shift-form-3"
  }, {
    path: "/landing/navigating-the-digital-shift-final",
    component: _459eabdc,
    name: "landing-navigating-the-digital-shift-final"
  }, {
    path: "/landing/changing-times-for-the-uk-payments-landscape",
    component: _459eabdc,
    name: "landing-changing-times-for-the-uk-payments-landscape"
  }, {
    path: "/landing/customer-focus-building-a-trusted-brand-and-addressing-operational-resilience",
    component: _459eabdc,
    name: "landing-customer-focus-building-a-trusted-brand-and-addressing-operational-resilience"
  }, {
    path: "/landing/download-webinar-rethinking-a-platform-approach-to-payments",
    component: _459eabdc,
    name: "landing-download-webinar-rethinking-a-platform-approach-to-payments"
  }, {
    path: "/landing/gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration1",
    component: _459eabdc,
    name: "landing-gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration1"
  }, {
    path: "/landing/ebaday",
    component: _459eabdc,
    name: "landing-ebaday"
  }, {
    path: "/landing/how-industry-events-shape-form3s-customer-and-partner-focus",
    component: _459eabdc,
    name: "landing-how-industry-events-shape-form3s-customer-and-partner-focus"
  }, {
    path: "/landing/lets-celebrate-diversity",
    component: _459eabdc,
    name: "landing-lets-celebrate-diversity"
  }, {
    path: "/landing/why-orchestration-is-key-for-payment-modernization",
    component: _459eabdc,
    name: "landing-why-orchestration-is-key-for-payment-modernization"
  }, {
    path: "/landing/datos",
    component: _459eabdc,
    name: "landing-datos"
  }, {
    path: "/landing/helping-global-fintechs-shape-the-future-of-payments",
    component: _459eabdc,
    name: "landing-helping-global-fintechs-shape-the-future-of-payments"
  }, {
    path: "/landing/our-next-milestone-cracking-the-us-market",
    component: _459eabdc,
    name: "landing-our-next-milestone-cracking-the-us-market"
  }, {
    path: "/landing/fincrime360",
    component: _459eabdc,
    name: "landing-fincrime360"
  }, {
    path: "/landing/preparing-for-a-year-of-regulatory-changes",
    component: _459eabdc,
    name: "landing-preparing-for-a-year-of-regulatory-changes"
  }, {
    path: "/landing/key-payments-industry-predictions-for-2025",
    component: _459eabdc,
    name: "landing-key-payments-industry-predictions-for-2025"
  }, {
    path: "/landing/nacha",
    component: _459eabdc,
    name: "landing-nacha"
  }, {
    path: "/landing/managing-change-in-financial-markets-and-payment-regulation",
    component: _459eabdc,
    name: "landing-managing-change-in-financial-markets-and-payment-regulation"
  }, {
    path: "/landing/reshaping-form3-to-achieve-profitability",
    component: _459eabdc,
    name: "landing-reshaping-form3-to-achieve-profitability"
  }, {
    path: "/landing/money-2020",
    component: _459eabdc,
    name: "landing-money-2020"
  }, {
    path: "/news/press-releases/form3s-unique-platform",
    component: _0f30e057,
    name: "news/press-releases-form3s-unique-platform"
  }, {
    path: "/news/press-releases/gocardless-selects-form3-for-bacs-payment",
    component: _0f30e057,
    name: "news/press-releases-gocardless-selects-form3-for-bacs-payment"
  }, {
    path: "/news/press-releases/form3-appoints-mark-fieldhouse-as-chief-revenue-officer",
    component: _0f30e057,
    name: "news/press-releases-form3-appoints-mark-fieldhouse-as-chief-revenue-officer"
  }, {
    path: "/news/press-releases/form3-series-c-extension",
    component: _0f30e057,
    name: "news/press-releases-form3-series-c-extension"
  }, {
    path: "/news/press-releases/datos-insights-2024-impact-award-for-best-app-prevention-innovation",
    component: _0f30e057,
    name: "news/press-releases-datos-insights-2024-impact-award-for-best-app-prevention-innovation"
  }, {
    path: "/news/press-releases/currencycloud-partners-with-form3",
    component: _0f30e057,
    name: "news/press-releases-currencycloud-partners-with-form3"
  }, {
    path: "/news/press-releases/form3-and-feedzai-launch-industry-first-app-fraud-solution",
    component: _0f30e057,
    name: "news/press-releases-form3-and-feedzai-launch-industry-first-app-fraud-solution"
  }, {
    path: "/news/press-releases/form3-appoints-anil-arora-as-non-executive-director",
    component: _0f30e057,
    name: "news/press-releases-form3-appoints-anil-arora-as-non-executive-director"
  }, {
    path: "/news/press-releases/klarna-european-payments",
    component: _0f30e057,
    name: "news/press-releases-klarna-european-payments"
  }, {
    path: "/news/press-releases/thought-machine-partners-with-form3",
    component: _0f30e057,
    name: "news/press-releases-thought-machine-partners-with-form3"
  }, {
    path: "/news/press-releases/visa-invests-in-form3-reducing-fraud-and-increasing-operational-efficiency",
    component: _0f30e057,
    name: "news/press-releases-visa-invests-in-form3-reducing-fraud-and-increasing-operational-efficiency"
  }, {
    path: "/news/press-releases/form3-appoints-matt-tuck-as-its-new-chief-commercial-officer",
    component: _0f30e057,
    name: "news/press-releases-form3-appoints-matt-tuck-as-its-new-chief-commercial-officer"
  }, {
    path: "/news/press-releases/certification-for-federal-reserves-new-instant-payment-service",
    component: _0f30e057,
    name: "news/press-releases-certification-for-federal-reserves-new-instant-payment-service"
  }, {
    path: "/news/press-releases/sumup-selects-form3-for-uk-payments-to-boost-growth",
    component: _0f30e057,
    name: "news/press-releases-sumup-selects-form3-for-uk-payments-to-boost-growth"
  }, {
    path: "/news/press-releases/the-payments-association-whitepaper-in-collaboration-with-form3",
    component: _0f30e057,
    name: "news/press-releases-the-payments-association-whitepaper-in-collaboration-with-form3"
  }, {
    path: "/news/press-releases/nationwide-building-society-accenture-form3",
    component: _0f30e057,
    name: "news/press-releases-nationwide-building-society-accenture-form3"
  }, {
    path: "/news/press-releases/form3-signs-clarency-for-swift-api-solution",
    component: _0f30e057,
    name: "news/press-releases-form3-signs-clarency-for-swift-api-solution"
  }, {
    path: "/news/press-releases/soldo-partnership",
    component: _0f30e057,
    name: "news/press-releases-soldo-partnership"
  }, {
    path: "/news/press-releases/form3-sponsors-payments-association-working-group-to-tackle-uk-digital-and-financial-crime",
    component: _0f30e057,
    name: "news/press-releases-form3-sponsors-payments-association-working-group-to-tackle-uk-digital-and-financial-crime"
  }, {
    path: "/news/press-releases/form3-secures-eur23-million-funding-to-continue-exponential-growth-journey",
    component: _0f30e057,
    name: "news/press-releases-form3-secures-eur23-million-funding-to-continue-exponential-growth-journey"
  }, {
    path: "/news/press-releases/form3-to-launch-cloud-native-api-swift-connectivity",
    component: _0f30e057,
    name: "news/press-releases-form3-to-launch-cloud-native-api-swift-connectivity"
  }, {
    path: "/news/press-releases/shawn-meyer-joins-form3-as-sales-specialist-in-the-us",
    component: _0f30e057,
    name: "news/press-releases-shawn-meyer-joins-form3-as-sales-specialist-in-the-us"
  }, {
    path: "/news/press-releases/jeremy-bambace-joins-form3-as-a-us-product-manager",
    component: _0f30e057,
    name: "news/press-releases-jeremy-bambace-joins-form3-as-a-us-product-manager"
  }, {
    path: "/news/press-releases/form3-joins-fednow-pilot-program-to-drive-modernization",
    component: _0f30e057,
    name: "news/press-releases-form3-joins-fednow-pilot-program-to-drive-modernization"
  }, {
    path: "/news/press-releases/seedrs-lhv-uk-fps",
    component: _0f30e057,
    name: "news/press-releases-seedrs-lhv-uk-fps"
  }, {
    path: "/news/press-releases/miriam-sheril",
    component: _0f30e057,
    name: "news/press-releases-miriam-sheril"
  }, {
    path: "/news/press-releases/form3-barclays-sepa-ebury",
    component: _0f30e057,
    name: "news/press-releases-form3-barclays-sepa-ebury"
  }, {
    path: "/news/press-releases/form3-hires-ex-swift-chief-executive-for-us-market",
    component: _0f30e057,
    name: "news/press-releases-form3-hires-ex-swift-chief-executive-for-us-market"
  }, {
    path: "/news/press-releases/form3-barclays-sepa-credit-transfer",
    component: _0f30e057,
    name: "news/press-releases-form3-barclays-sepa-credit-transfer"
  }, {
    path: "/news/press-releases/form3-simeon-lando",
    component: _0f30e057,
    name: "news/press-releases-form3-simeon-lando"
  }, {
    path: "/news/press-releases/form3-raises-160-million",
    component: _0f30e057,
    name: "news/press-releases-form3-raises-160-million"
  }, {
    path: "/news/press-releases/form3-mastercard-payport-gateway",
    component: _0f30e057,
    name: "news/press-releases-form3-mastercard-payport-gateway"
  }, {
    path: "/news/press-releases/form3-nationwide-strategic-partnership",
    component: _0f30e057,
    name: "news/press-releases-form3-nationwide-strategic-partnership"
  }, {
    path: "/news/press-releases/form3-expanded-leadership-team",
    component: _0f30e057,
    name: "news/press-releases-form3-expanded-leadership-team"
  }, {
    path: "/news/press-releases/form3-aion-bank-finances",
    component: _0f30e057,
    name: "news/press-releases-form3-aion-bank-finances"
  }, {
    path: "/news/press-releases/form3-mastercard-strategic-partnership",
    component: _0f30e057,
    name: "news/press-releases-form3-mastercard-strategic-partnership"
  }, {
    path: "/news/press-releases/form3-raise-33-million-lloyds-nationwide-83north",
    component: _0f30e057,
    name: "news/press-releases-form3-raise-33-million-lloyds-nationwide-83north"
  }, {
    path: "/news/press-releases/form3-lloyds-strategic-partnership",
    component: _0f30e057,
    name: "news/press-releases-form3-lloyds-strategic-partnership"
  }, {
    path: "/news/press-releases/form3-lhv-europe",
    component: _0f30e057,
    name: "news/press-releases-form3-lhv-europe"
  }, {
    path: "/news/press-releases/form3-aws-competency-status",
    component: _0f30e057,
    name: "news/press-releases-form3-aws-competency-status"
  }, {
    path: "/news/press-releases/payments-as-a-service-first-choice-for-financial-institutions",
    component: _0f30e057,
    name: "news/press-releases-payments-as-a-service-first-choice-for-financial-institutions"
  }, {
    path: "/news/press-releases/form3-bonnie-mitchell-joins",
    component: _0f30e057,
    name: "news/press-releases-form3-bonnie-mitchell-joins"
  }, {
    path: "/news/press-releases/form3-and-bpc-announce-partnership-to-combine-expertise",
    component: _0f30e057,
    name: "news/press-releases-form3-and-bpc-announce-partnership-to-combine-expertise"
  }, {
    path: "/news/press-releases/form3-european-expansion",
    component: _0f30e057,
    name: "news/press-releases-form3-european-expansion"
  }, {
    path: "/news/press-releases/form3-raise-13million",
    component: _0f30e057,
    name: "news/press-releases-form3-raise-13million"
  }, {
    path: "/news/press-releases/form3-lhv-faster-payments-direct",
    component: _0f30e057,
    name: "news/press-releases-form3-lhv-faster-payments-direct"
  }, {
    path: "/news/press-releases/form3-mambu-real-time-payments",
    component: _0f30e057,
    name: "news/press-releases-form3-mambu-real-time-payments"
  }, {
    path: "/news/press-releases/form3-tandem-ux",
    component: _0f30e057,
    name: "news/press-releases-form3-tandem-ux"
  }, {
    path: "/news/press-releases/ebury-form3-go-live",
    component: _0f30e057,
    name: "news/press-releases-ebury-form3-go-live"
  }, {
    path: "/blog/culture/male-health",
    component: _2ed58028,
    name: "blog/culture-male-health"
  }, {
    path: "/blog/culture/my-journey-as-a-ba-apprentice",
    component: _2ed58028,
    name: "blog/culture-my-journey-as-a-ba-apprentice"
  }, {
    path: "/blog/culture/my-first-6-months",
    component: _2ed58028,
    name: "blog/culture-my-first-6-months"
  }, {
    path: "/blog/culture/investment-time",
    component: _2ed58028,
    name: "blog/culture-investment-time"
  }, {
    path: "/blog/culture/fr3shers",
    component: _2ed58028,
    name: "blog/culture-fr3shers"
  }, {
    path: "/blog/culture/michael-mueller-story",
    component: _2ed58028,
    name: "blog/culture-michael-mueller-story"
  }, {
    path: "/blog/culture/womens-health",
    component: _2ed58028,
    name: "blog/culture-womens-health"
  }, {
    path: "/blog/culture/internal-mobility",
    component: _2ed58028,
    name: "blog/culture-internal-mobility"
  }, {
    path: "/blog/culture/legal-team-apprentice",
    component: _2ed58028,
    name: "blog/culture-legal-team-apprentice"
  }, {
    path: "/blog/culture/building-our-unique-security-team",
    component: _2ed58028,
    name: "blog/culture-building-our-unique-security-team"
  }, {
    path: "/blog/culture/how-we-came-up-with-our-company-values",
    component: _2ed58028,
    name: "blog/culture-how-we-came-up-with-our-company-values"
  }, {
    path: "/blog/culture/environmental-impact-and-earth-day",
    component: _2ed58028,
    name: "blog/culture-environmental-impact-and-earth-day"
  }, {
    path: "/blog/culture/furry-friends-of-form3",
    component: _2ed58028,
    name: "blog/culture-furry-friends-of-form3"
  }, {
    path: "/blog/culture/how-we-celebrated-lgbt-history-month-at-form3",
    component: _2ed58028,
    name: "blog/culture-how-we-celebrated-lgbt-history-month-at-form3"
  }, {
    path: "/blog/culture/how-form3-is-shaping-a-more-inclusive-future-for-people",
    component: _2ed58028,
    name: "blog/culture-how-form3-is-shaping-a-more-inclusive-future-for-people"
  }, {
    path: "/blog/culture/celebrating-womens-history-month-being-a-new-working",
    component: _2ed58028,
    name: "blog/culture-celebrating-womens-history-month-being-a-new-working"
  }, {
    path: "/blog/culture/our-interview-process",
    component: _2ed58028,
    name: "blog/culture-our-interview-process"
  }, {
    path: "/blog/culture/our-promise-to-you",
    component: _2ed58028,
    name: "blog/culture-our-promise-to-you"
  }, {
    path: "/blog/culture/from-security-recruiter-to-vulnerability-analyst-at-form3",
    component: _2ed58028,
    name: "blog/culture-from-security-recruiter-to-vulnerability-analyst-at-form3"
  }, {
    path: "/blog/culture/international-womens-day-2023",
    component: _2ed58028,
    name: "blog/culture-international-womens-day-2023"
  }, {
    path: "/blog/culture/can-you-please-introduce-yourself-your-role-and-what",
    component: _2ed58028,
    name: "blog/culture-can-you-please-introduce-yourself-your-role-and-what"
  }, {
    path: "/blog/culture/planning-our-learning-for-the-year-ahead",
    component: _2ed58028,
    name: "blog/culture-planning-our-learning-for-the-year-ahead"
  }, {
    path: "/blog/culture/november-was-national-tree-week-at-form3",
    component: _2ed58028,
    name: "blog/culture-november-was-national-tree-week-at-form3"
  }, {
    path: "/blog/culture/dream-remote-software-engineer-job",
    component: _2ed58028,
    name: "blog/culture-dream-remote-software-engineer-job"
  }, {
    path: "/blog/culture/intentionally-international",
    component: _2ed58028,
    name: "blog/culture-intentionally-international"
  }, {
    path: "/blog/culture/celebrating-500-employees",
    component: _2ed58028,
    name: "blog/culture-celebrating-500-employees"
  }, {
    path: "/blog/culture/fostering-healthy-teams-at-form3",
    component: _2ed58028,
    name: "blog/culture-fostering-healthy-teams-at-form3"
  }, {
    path: "/blog/culture/black-history-month-at-form3",
    component: _2ed58028,
    name: "blog/culture-black-history-month-at-form3"
  }, {
    path: "/blog/culture/how-form3-holds-effective-meetings",
    component: _2ed58028,
    name: "blog/culture-how-form3-holds-effective-meetings"
  }, {
    path: "/blog/culture/its-all-about-communication",
    component: _2ed58028,
    name: "blog/culture-its-all-about-communication"
  }, {
    path: "/blog/culture/on-mental-health-as-a-manager",
    component: _2ed58028,
    name: "blog/culture-on-mental-health-as-a-manager"
  }, {
    path: "/blog/culture/psychological-safety-at-form3",
    component: _2ed58028,
    name: "blog/culture-psychological-safety-at-form3"
  }, {
    path: "/blog/culture/how-form3-is-supporting-its-teams-mental-health",
    component: _2ed58028,
    name: "blog/culture-how-form3-is-supporting-its-teams-mental-health"
  }, {
    path: "/blog/culture/keeping-connected-in-a-remote-first-business",
    component: _2ed58028,
    name: "blog/culture-keeping-connected-in-a-remote-first-business"
  }, {
    path: "/blog/culture/form3-cares-about-the-planet",
    component: _2ed58028,
    name: "blog/culture-form3-cares-about-the-planet"
  }, {
    path: "/blog/culture/meet-form3s-esg-intern",
    component: _2ed58028,
    name: "blog/culture-meet-form3s-esg-intern"
  }, {
    path: "/blog/culture/setting-our-team-up-for-successful-remote-work",
    component: _2ed58028,
    name: "blog/culture-setting-our-team-up-for-successful-remote-work"
  }, {
    path: "/blog/culture/our-culture-of-continuous-learning",
    component: _2ed58028,
    name: "blog/culture-our-culture-of-continuous-learning"
  }, {
    path: "/blog/culture/form3s-approach-to-giving-back",
    component: _2ed58028,
    name: "blog/culture-form3s-approach-to-giving-back"
  }, {
    path: "/blog/culture/male-allies-at-form3-on-international-womens-day",
    component: _2ed58028,
    name: "blog/culture-male-allies-at-form3-on-international-womens-day"
  }, {
    path: "/blog/culture/international-womens-day-spotlight-the-life-of-a",
    component: _2ed58028,
    name: "blog/culture-international-womens-day-spotlight-the-life-of-a"
  }, {
    path: "/blog/culture/asynchronous-communication",
    component: _2ed58028,
    name: "blog/culture-asynchronous-communication"
  }, {
    path: "/blog/culture/diversity-update-a-year-in-review",
    component: _2ed58028,
    name: "blog/culture-diversity-update-a-year-in-review"
  }, {
    path: "/blog/culture/form3s-first-apprentice",
    component: _2ed58028,
    name: "blog/culture-form3s-first-apprentice"
  }, {
    path: "/blog/culture/female-leadership-spotlight---penny-hughes",
    component: _2ed58028,
    name: "blog/culture-female-leadership-spotlight---penny-hughes"
  }, {
    path: "/blog/culture/female-leadership-spotlight-eimear-oconnor",
    component: _2ed58028,
    name: "blog/culture-female-leadership-spotlight-eimear-oconnor"
  }, {
    path: "/blog/culture/female-leadership-spotlight--bonnie-mitchell",
    component: _2ed58028,
    name: "blog/culture-female-leadership-spotlight--bonnie-mitchell"
  }, {
    path: "/blog/culture/international-womens-day",
    component: _2ed58028,
    name: "blog/culture-international-womens-day"
  }, {
    path: "/blog/culture/a-remote-first-culture",
    component: _2ed58028,
    name: "blog/culture-a-remote-first-culture"
  }, {
    path: "/blog/culture/women-in-tech",
    component: _2ed58028,
    name: "blog/culture-women-in-tech"
  }, {
    path: "/",
    component: _f550116e,
    name: "index"
  }, {
    path: "/:lang",
    component: _f6237172,
    name: "lang"
  }, {
    path: "/:lang/404",
    component: _ece25026,
    name: "lang-404"
  }, {
    path: "/:lang/about",
    component: _366c0985,
    name: "lang-about"
  }, {
    path: "/:lang/additional-services",
    component: _70fd8dbc,
    name: "lang-additional-services"
  }, {
    path: "/:lang/blog",
    component: _3c95d180,
    name: "lang-blog"
  }, {
    path: "/:lang/careers",
    component: _7fcf296d,
    name: "lang-careers"
  }, {
    path: "/:lang/contact",
    component: _11ca5b18,
    name: "lang-contact"
  }, {
    path: "/:lang/culture",
    component: _03bd7326,
    name: "lang-culture"
  }, {
    path: "/:lang/debug",
    component: _3d533ccb,
    name: "lang-debug"
  }, {
    path: "/:lang/engineering",
    component: _bba8086a,
    name: "lang-engineering"
  }, {
    path: "/:lang/europe",
    component: _bfd4da80,
    name: "lang-europe"
  }, {
    path: "/:lang/news",
    component: _f4a8b91e,
    name: "lang-news"
  }, {
    path: "/:lang/platform",
    component: _5922c0de,
    name: "lang-platform"
  }, {
    path: "/:lang/united-kingdom",
    component: _02502aff,
    name: "lang-united-kingdom"
  }, {
    path: "/:lang/united-states",
    component: _4f777424,
    name: "lang-united-states"
  }, {
    path: "/:lang/about/approach",
    component: _1bc67408,
    name: "lang-about-approach"
  }, {
    path: "/:lang/about/awards",
    component: _45ee81d6,
    name: "lang-about-awards"
  }, {
    path: "/:lang/about/customer-stories",
    component: _4d095c78,
    name: "lang-about-customer-stories"
  }, {
    path: "/:lang/about/net-zero",
    component: _3b78dd90,
    name: "lang-about-net-zero"
  }, {
    path: "/:lang/about/our-story",
    component: _77bb8aaa,
    name: "lang-about-our-story"
  }, {
    path: "/:lang/about/partners",
    component: _0ea3f14b,
    name: "lang-about-partners"
  }, {
    path: "/:lang/about/team",
    component: _56542a06,
    name: "lang-about-team"
  }, {
    path: "/:lang/additional-services/account-management",
    component: _1f1f9aa8,
    name: "lang-additional-services-account-management"
  }, {
    path: "/:lang/additional-services/cop",
    component: _5ce0741e,
    name: "lang-additional-services-cop"
  }, {
    path: "/:lang/additional-services/fraud",
    component: _42580a51,
    name: "lang-additional-services-fraud"
  }, {
    path: "/:lang/additional-services/metrics",
    component: _f3f26d20,
    name: "lang-additional-services-metrics"
  }, {
    path: "/:lang/additional-services/on-us",
    component: _2a60c739,
    name: "lang-additional-services-on-us"
  }, {
    path: "/:lang/additional-services/orchestration",
    component: _0b0df024,
    name: "lang-additional-services-orchestration"
  }, {
    path: "/:lang/additional-services/vop",
    component: _f56d7cf8,
    name: "lang-additional-services-vop"
  }, {
    path: "/:lang/blog/culture",
    component: _0b77b45f,
    name: "lang-blog-culture"
  }, {
    path: "/:lang/blog/engineering",
    component: _57fe0ef8,
    name: "lang-blog-engineering"
  }, {
    path: "/:lang/careers/vacancies",
    component: _64bec577,
    name: "lang-careers-vacancies"
  }, {
    path: "/:lang/contact/error",
    component: _24f7655e,
    name: "lang-contact-error"
  }, {
    path: "/:lang/contact/thank-you",
    component: _78408e05,
    name: "lang-contact-thank-you"
  }, {
    path: "/:lang/engineering/accreditations",
    component: _51dc15d3,
    name: "lang-engineering-accreditations"
  }, {
    path: "/:lang/engineering/content",
    component: _420b80b5,
    name: "lang-engineering-content"
  }, {
    path: "/:lang/engineering/life-at-form3",
    component: _ba34067c,
    name: "lang-engineering-life-at-form3"
  }, {
    path: "/:lang/europe/sepa",
    component: _5f8b16f0,
    name: "lang-europe-sepa"
  }, {
    path: "/:lang/europe/sepa-credit-transfer",
    component: _614a6c7a,
    name: "lang-europe-sepa-credit-transfer"
  }, {
    path: "/:lang/europe/sepa-direct-debit",
    component: _655b697a,
    name: "lang-europe-sepa-direct-debit"
  }, {
    path: "/:lang/europe/sepa-instant",
    component: _e5ab10c8,
    name: "lang-europe-sepa-instant"
  }, {
    path: "/:lang/legal/cookie-policy",
    component: _bc77c5c6,
    name: "lang-legal-cookie-policy"
  }, {
    path: "/:lang/legal/data-privacy-statement",
    component: _8897ad8a,
    name: "lang-legal-data-privacy-statement"
  }, {
    path: "/:lang/legal/license",
    component: _332e933a,
    name: "lang-legal-license"
  }, {
    path: "/:lang/legal/modern-slavery",
    component: _56042ab8,
    name: "lang-legal-modern-slavery"
  }, {
    path: "/:lang/legal/recruitment-data-policy",
    component: _3185e334,
    name: "lang-legal-recruitment-data-policy"
  }, {
    path: "/:lang/legal/terms-and-conditions",
    component: _30274ab0,
    name: "lang-legal-terms-and-conditions"
  }, {
    path: "/:lang/news/payment-insights",
    component: _5d24da36,
    name: "lang-news-payment-insights"
  }, {
    path: "/:lang/news/press-releases",
    component: _4127274a,
    name: "lang-news-press-releases"
  }, {
    path: "/:lang/platform/connect",
    component: _9dd7aca8,
    name: "lang-platform-connect"
  }, {
    path: "/:lang/platform/escrow",
    component: _8760e3ce,
    name: "lang-platform-escrow"
  }, {
    path: "/:lang/platform/international",
    component: _3ab4e910,
    name: "lang-platform-international"
  }, {
    path: "/:lang/platform/multicloud",
    component: _70b7cd30,
    name: "lang-platform-multicloud"
  }, {
    path: "/:lang/platform/security",
    component: _1eeaa5d8,
    name: "lang-platform-security"
  }, {
    path: "/:lang/platform/simulator",
    component: _59fe6e86,
    name: "lang-platform-simulator"
  }, {
    path: "/:lang/united-kingdom/uk",
    component: _f0d83508,
    name: "lang-united-kingdom-uk"
  }, {
    path: "/:lang/united-kingdom/uk-instant",
    component: _1d4db490,
    name: "lang-united-kingdom-uk-instant"
  }, {
    path: "/:lang/united-states/us",
    component: _c51b3782,
    name: "lang-united-states-us"
  }, {
    path: "/:lang/united-states/us-instant",
    component: _13eec053,
    name: "lang-united-states-us-instant"
  }, {
    path: "/:lang/platform/international/swift",
    component: _21de9b94,
    name: "lang-platform-international-swift"
  }, {
    path: "/:lang/careers/vacancies/:jobId/:jobTitle?",
    component: _3c6f0d38,
    name: "lang-careers-vacancies-jobId"
  }, {
    path: "/:lang/news/press-releases/*",
    component: _0f30e057,
    name: "lang-news-press-releases-all"
  }, {
    path: "/:lang/news/payment-insights/*",
    component: _6f74e943,
    name: "lang-news-payment-insights-all"
  }, {
    path: "/:lang/engineering/who-we-are/*",
    component: _7ab26e2a,
    name: "lang-engineering-who-we-are-all"
  }, {
    path: "/:lang/engineering/content/*",
    component: _1878a742,
    name: "lang-engineering-content-all"
  }, {
    path: "/:lang/blog/engineering/*",
    component: _52c85e91,
    name: "lang-blog-engineering-all"
  }, {
    path: "/:lang/blog/culture/*",
    component: _2ed58028,
    name: "lang-blog-culture-all"
  }, {
    path: "/:lang/landing/*",
    component: _459eabdc,
    name: "lang-landing-all"
  }, {
    path: "/:lang/campaigns/*",
    component: _38407230,
    name: "lang-campaigns-all"
  }, {
    path: "/:lang/news/payment-insights/real-time-payments-a-revenue-opportunity-for-mid-sized-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-real-time-payments-a-revenue-opportunity-for-mid-sized-banks"
  }, {
    path: "/:lang/news/payment-insights/verification-of-payee-deadline-what-banks-must-do-to-meet-epc-requirements",
    component: _6f74e943,
    name: "lang-news/payment-insights-verification-of-payee-deadline-what-banks-must-do-to-meet-epc-requirements"
  }, {
    path: "/:lang/news/payment-insights/why-multicloud-is-the-future",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-multicloud-is-the-future"
  }, {
    path: "/:lang/news/payment-insights/why-orchestration-is-a-key-driver-in-payment-modernisation",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-orchestration-is-a-key-driver-in-payment-modernisation"
  }, {
    path: "/:lang/news/payment-insights/verification-of-payee-regulation-overview",
    component: _6f74e943,
    name: "lang-news/payment-insights-verification-of-payee-regulation-overview"
  }, {
    path: "/:lang/news/payment-insights/why-mid-sized-banks-cant-afford-to-ignore-real-time-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-mid-sized-banks-cant-afford-to-ignore-real-time-payments"
  }, {
    path: "/:lang/news/payment-insights/resilient-real-time-payments-ecosystem",
    component: _6f74e943,
    name: "lang-news/payment-insights-resilient-real-time-payments-ecosystem"
  }, {
    path: "/:lang/news/payment-insights/harnessing-instant-payments-in-the-us-with-the-rtp-network",
    component: _6f74e943,
    name: "lang-news/payment-insights-harnessing-instant-payments-in-the-us-with-the-rtp-network"
  }, {
    path: "/:lang/news/payment-insights/key-us-payment-trends-in-2025-and-beyond-that-banks-need-to-be-aware-of",
    component: _6f74e943,
    name: "lang-news/payment-insights-key-us-payment-trends-in-2025-and-beyond-that-banks-need-to-be-aware-of"
  }, {
    path: "/:lang/news/payment-insights/fednows-first-birthday-reflects-strong-faster-payments-progress",
    component: _6f74e943,
    name: "lang-news/payment-insights-fednows-first-birthday-reflects-strong-faster-payments-progress"
  }, {
    path: "/:lang/news/payment-insights/year-in-review-2024-payment-landscape",
    component: _6f74e943,
    name: "lang-news/payment-insights-year-in-review-2024-payment-landscape"
  }, {
    path: "/:lang/news/payment-insights/sepa-instant-payments-2025-rulebook-updates",
    component: _6f74e943,
    name: "lang-news/payment-insights-sepa-instant-payments-2025-rulebook-updates"
  }, {
    path: "/:lang/news/payment-insights/compliance-with-the-eu-digital-operational-resilience-act",
    component: _6f74e943,
    name: "lang-news/payment-insights-compliance-with-the-eu-digital-operational-resilience-act"
  }, {
    path: "/:lang/news/payment-insights/building-operational-resilience",
    component: _6f74e943,
    name: "lang-news/payment-insights-building-operational-resilience"
  }, {
    path: "/:lang/news/payment-insights/how-traditional-banking-tech-infrastructure-is-being-transformed",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-traditional-banking-tech-infrastructure-is-being-transformed"
  }, {
    path: "/:lang/news/payment-insights/how-form3s-metrics-service-opens-up-granular-insights",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-form3s-metrics-service-opens-up-granular-insights"
  }, {
    path: "/:lang/news/payment-insights/how-multi-cloud-supports-operational-resilience-in-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-multi-cloud-supports-operational-resilience-in-payments"
  }, {
    path: "/:lang/news/payment-insights/innovation-and-regulation",
    component: _6f74e943,
    name: "lang-news/payment-insights-innovation-and-regulation"
  }, {
    path: "/:lang/news/payment-insights/key-to-uk-modernisation-for-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-key-to-uk-modernisation-for-banks"
  }, {
    path: "/:lang/news/payment-insights/vop",
    component: _6f74e943,
    name: "lang-news/payment-insights-vop"
  }, {
    path: "/:lang/news/payment-insights/psd3-and-fintechs",
    component: _6f74e943,
    name: "lang-news/payment-insights-psd3-and-fintechs"
  }, {
    path: "/:lang/news/payment-insights/multicloud-approach-to-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-multicloud-approach-to-payments"
  }, {
    path: "/:lang/news/payment-insights/webinar-rethinking-a-platform-approach-to-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-webinar-rethinking-a-platform-approach-to-payments"
  }, {
    path: "/:lang/news/payment-insights/navigating-the-digital-shift",
    component: _6f74e943,
    name: "lang-news/payment-insights-navigating-the-digital-shift"
  }, {
    path: "/:lang/news/payment-insights/real-time-payments-need-orchestration-layer-to-solve-interoperability-gap",
    component: _6f74e943,
    name: "lang-news/payment-insights-real-time-payments-need-orchestration-layer-to-solve-interoperability-gap"
  }, {
    path: "/:lang/news/payment-insights/pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards",
    component: _6f74e943,
    name: "lang-news/payment-insights-pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards"
  }, {
    path: "/:lang/news/payment-insights/misconceptions-of-payment-orchestration",
    component: _6f74e943,
    name: "lang-news/payment-insights-misconceptions-of-payment-orchestration"
  }, {
    path: "/:lang/news/payment-insights/apis-promise-to-make-instant-payment-systems-interoperable",
    component: _6f74e943,
    name: "lang-news/payment-insights-apis-promise-to-make-instant-payment-systems-interoperable"
  }, {
    path: "/:lang/news/payment-insights/demystifying-payment-modernization",
    component: _6f74e943,
    name: "lang-news/payment-insights-demystifying-payment-modernization"
  }, {
    path: "/:lang/news/payment-insights/demystifying-payment-modernization-separating-fact-from-fiction",
    component: _6f74e943,
    name: "lang-news/payment-insights-demystifying-payment-modernization-separating-fact-from-fiction"
  }, {
    path: "/:lang/news/payment-insights/elevating-payment-standards-with-form3-a-vision-of-efficiency-and-resilience",
    component: _6f74e943,
    name: "lang-news/payment-insights-elevating-payment-standards-with-form3-a-vision-of-efficiency-and-resilience"
  }, {
    path: "/:lang/news/payment-insights/what-will-be-the-key-trends-in-payments-in-2024",
    component: _6f74e943,
    name: "lang-news/payment-insights-what-will-be-the-key-trends-in-payments-in-2024"
  }, {
    path: "/:lang/news/payment-insights/what-banks-and-psps-need-to-do-in-2024-to-enable-seamless-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-what-banks-and-psps-need-to-do-in-2024-to-enable-seamless-payments"
  }, {
    path: "/:lang/news/payment-insights/form3-payments-trends-banks-need-to-be-aware-of-in-2024",
    component: _6f74e943,
    name: "lang-news/payment-insights-form3-payments-trends-banks-need-to-be-aware-of-in-2024"
  }, {
    path: "/:lang/news/payment-insights/industry-focus-trends-in-fintech-that-drive-growth",
    component: _6f74e943,
    name: "lang-news/payment-insights-industry-focus-trends-in-fintech-that-drive-growth"
  }, {
    path: "/:lang/news/payment-insights/new-use-cases-needed-to-drive-instant-payments-momentum-worldwide",
    component: _6f74e943,
    name: "lang-news/payment-insights-new-use-cases-needed-to-drive-instant-payments-momentum-worldwide"
  }, {
    path: "/:lang/news/payment-insights/five-months-in-fednow-is-doing-what-it-was-planned-to-do",
    component: _6f74e943,
    name: "lang-news/payment-insights-five-months-in-fednow-is-doing-what-it-was-planned-to-do"
  }, {
    path: "/:lang/news/payment-insights/b2b-payments-need-foundational-infrastructure",
    component: _6f74e943,
    name: "lang-news/payment-insights-b2b-payments-need-foundational-infrastructure"
  }, {
    path: "/:lang/news/payment-insights/fedwire-will-get-boost-from-iso-200221",
    component: _6f74e943,
    name: "lang-news/payment-insights-fedwire-will-get-boost-from-iso-200221"
  }, {
    path: "/:lang/news/payment-insights/unleash-the-power-of-iso-20022",
    component: _6f74e943,
    name: "lang-news/payment-insights-unleash-the-power-of-iso-20022"
  }, {
    path: "/:lang/news/payment-insights/unleashing-hyper-automation-the-next-frontier-in-payment-innovation",
    component: _6f74e943,
    name: "lang-news/payment-insights-unleashing-hyper-automation-the-next-frontier-in-payment-innovation"
  }, {
    path: "/:lang/news/payment-insights/instant-payments-force-banks-to-examine-limitations-of-creaky-legacy-systems",
    component: _6f74e943,
    name: "lang-news/payment-insights-instant-payments-force-banks-to-examine-limitations-of-creaky-legacy-systems"
  }, {
    path: "/:lang/news/payment-insights/why-psps-must-act-now-on-psr-requirements",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-psps-must-act-now-on-psr-requirements"
  }, {
    path: "/:lang/news/payment-insights/form3-announces-three-management-changes",
    component: _6f74e943,
    name: "lang-news/payment-insights-form3-announces-three-management-changes"
  }, {
    path: "/:lang/news/payment-insights/understanding-fpad-a-game-changer-for-european-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-understanding-fpad-a-game-changer-for-european-banks"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-advancing-payment-innovation",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-advancing-payment-innovation"
  }, {
    path: "/:lang/news/payment-insights/real-time-payments-pave-way-for-further-adoption-of-platform-as-a-service-models",
    component: _6f74e943,
    name: "lang-news/payment-insights-real-time-payments-pave-way-for-further-adoption-of-platform-as-a-service-models"
  }, {
    path: "/:lang/news/payment-insights/panel-real-time-ubiquity-and-connectivity-turn-payments-into-satisfaction-tools",
    component: _6f74e943,
    name: "lang-news/payment-insights-panel-real-time-ubiquity-and-connectivity-turn-payments-into-satisfaction-tools"
  }, {
    path: "/:lang/news/payment-insights/gated-content-pymnts-livestream-interoperability",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-pymnts-livestream-interoperability"
  }, {
    path: "/:lang/news/payment-insights/enhancing-payment-security-in-the-uk-the-role-of-confirmation-of-payee",
    component: _6f74e943,
    name: "lang-news/payment-insights-enhancing-payment-security-in-the-uk-the-role-of-confirmation-of-payee"
  }, {
    path: "/:lang/news/payment-insights/fednow-is-live-but-banks-face-integration-decisions",
    component: _6f74e943,
    name: "lang-news/payment-insights-fednow-is-live-but-banks-face-integration-decisions"
  }, {
    path: "/:lang/news/payment-insights/challenge-of-real-time-integration",
    component: _6f74e943,
    name: "lang-news/payment-insights-challenge-of-real-time-integration"
  }, {
    path: "/:lang/news/payment-insights/apis-revolutionize-connectivity-for-fis-and-set-stage-for-real-time-payments-success",
    component: _6f74e943,
    name: "lang-news/payment-insights-apis-revolutionize-connectivity-for-fis-and-set-stage-for-real-time-payments-success"
  }, {
    path: "/:lang/news/payment-insights/back-office-overhaul-critical-to-survival-in-faster-payments-landscape",
    component: _6f74e943,
    name: "lang-news/payment-insights-back-office-overhaul-critical-to-survival-in-faster-payments-landscape"
  }, {
    path: "/:lang/news/payment-insights/fednow-launch-pushes-banks-to-embrace-the-cloud",
    component: _6f74e943,
    name: "lang-news/payment-insights-fednow-launch-pushes-banks-to-embrace-the-cloud"
  }, {
    path: "/:lang/news/payment-insights/gated-content-how-apis-are-reshaping-the-payments-landscape",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-how-apis-are-reshaping-the-payments-landscape"
  }, {
    path: "/:lang/news/payment-insights/fednow-is-approaching",
    component: _6f74e943,
    name: "lang-news/payment-insights-fednow-is-approaching"
  }, {
    path: "/:lang/news/payment-insights/unravelling-psd3",
    component: _6f74e943,
    name: "lang-news/payment-insights-unravelling-psd3"
  }, {
    path: "/:lang/news/payment-insights/psd3-fraud-in-the-eurozone",
    component: _6f74e943,
    name: "lang-news/payment-insights-psd3-fraud-in-the-eurozone"
  }, {
    path: "/:lang/news/payment-insights/fraud-prevention-in-real-time-how-us-banks-can-stay-ahead-of-the-criminals",
    component: _6f74e943,
    name: "lang-news/payment-insights-fraud-prevention-in-real-time-how-us-banks-can-stay-ahead-of-the-criminals"
  }, {
    path: "/:lang/news/payment-insights/apis-powering-payments-igniting-growth-and-pioneering-the-future-of-banking",
    component: _6f74e943,
    name: "lang-news/payment-insights-apis-powering-payments-igniting-growth-and-pioneering-the-future-of-banking"
  }, {
    path: "/:lang/news/payment-insights/fednows-success-hinges-on-getting-enough-banks-to-connect--and-use-it",
    component: _6f74e943,
    name: "lang-news/payment-insights-fednows-success-hinges-on-getting-enough-banks-to-connect--and-use-it"
  }, {
    path: "/:lang/news/payment-insights/report-from-cloud-to-multicloud-a-pathway-to-resilience",
    component: _6f74e943,
    name: "lang-news/payment-insights-report-from-cloud-to-multicloud-a-pathway-to-resilience"
  }, {
    path: "/:lang/news/payment-insights/collaboration-across-industries-key-to-fraud-prevention",
    component: _6f74e943,
    name: "lang-news/payment-insights-collaboration-across-industries-key-to-fraud-prevention"
  }, {
    path: "/:lang/news/payment-insights/what-the-us-can-learn-from-the-uk-about-push-payments-fraud",
    component: _6f74e943,
    name: "lang-news/payment-insights-what-the-us-can-learn-from-the-uk-about-push-payments-fraud"
  }, {
    path: "/:lang/news/payment-insights/why-2025-may-not-be-enough-time-to-hit-iso-20022-transition-deadline",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-2025-may-not-be-enough-time-to-hit-iso-20022-transition-deadline"
  }, {
    path: "/:lang/news/payment-insights/batch-payments-to-become-a-long-lived-reality-in-real-time-world",
    component: _6f74e943,
    name: "lang-news/payment-insights-batch-payments-to-become-a-long-lived-reality-in-real-time-world"
  }, {
    path: "/:lang/news/payment-insights/gated-content-rethinking-testing-strategies-for-real-time-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-rethinking-testing-strategies-for-real-time-payments"
  }, {
    path: "/:lang/news/payment-insights/platforms-speed-banks-global-real-time-payments-plans",
    component: _6f74e943,
    name: "lang-news/payment-insights-platforms-speed-banks-global-real-time-payments-plans"
  }, {
    path: "/:lang/news/payment-insights/psr-changes",
    component: _6f74e943,
    name: "lang-news/payment-insights-psr-changes"
  }, {
    path: "/:lang/news/payment-insights/banks-look-to-the-cloud",
    component: _6f74e943,
    name: "lang-news/payment-insights-banks-look-to-the-cloud"
  }, {
    path: "/:lang/news/payment-insights/sepa-instant-international-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-sepa-instant-international-payments"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-data-uk-faster-payments-a-model-for-us-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-data-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/:lang/news/payment-insights/data-sharing-combat-financial-crime",
    component: _6f74e943,
    name: "lang-news/payment-insights-data-sharing-combat-financial-crime"
  }, {
    path: "/:lang/news/payment-insights/gated-content-navigating-integration-and-resilience-of-new-payment-schemes",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-navigating-integration-and-resilience-of-new-payment-schemes"
  }, {
    path: "/:lang/news/payment-insights/2023-eba-sepa-maintenance-release",
    component: _6f74e943,
    name: "lang-news/payment-insights-2023-eba-sepa-maintenance-release"
  }, {
    path: "/:lang/news/payment-insights/multi-cloud-operational-resilience",
    component: _6f74e943,
    name: "lang-news/payment-insights-multi-cloud-operational-resilience"
  }, {
    path: "/:lang/news/payment-insights/gated-content-decoding-the-sepa-instant-mandate",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-decoding-the-sepa-instant-mandate"
  }, {
    path: "/:lang/news/payment-insights/swift-as-a-service-international-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-swift-as-a-service-international-payments"
  }, {
    path: "/:lang/news/payment-insights/navigating-payments-transformation-for-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-navigating-payments-transformation-for-banks"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-data-sharing-to-prevent-economic-crime",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-data-sharing-to-prevent-economic-crime"
  }, {
    path: "/:lang/news/payment-insights/taking-the-stress-out-of-delivering-sepas-new-instant-payments-mandate",
    component: _6f74e943,
    name: "lang-news/payment-insights-taking-the-stress-out-of-delivering-sepas-new-instant-payments-mandate"
  }, {
    path: "/:lang/news/payment-insights/mastering-the-fednow-service-your-guide-to-instant-payments-in-the-us",
    component: _6f74e943,
    name: "lang-news/payment-insights-mastering-the-fednow-service-your-guide-to-instant-payments-in-the-us"
  }, {
    path: "/:lang/news/payment-insights/gated-content-why-now-for-fednow",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-why-now-for-fednow"
  }, {
    path: "/:lang/news/payment-insights/sepa-instant-payments-future-european-transactions",
    component: _6f74e943,
    name: "lang-news/payment-insights-sepa-instant-payments-future-european-transactions"
  }, {
    path: "/:lang/news/payment-insights/uk-faster-payments-a-model-for-us-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/:lang/news/payment-insights/gated-content-international-payments-build-buy-or-both",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-international-payments-build-buy-or-both"
  }, {
    path: "/:lang/news/payment-insights/cloud-optimisation-success-8-steps",
    component: _6f74e943,
    name: "lang-news/payment-insights-cloud-optimisation-success-8-steps"
  }, {
    path: "/:lang/news/payment-insights/testing-real-time-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-testing-real-time-payments"
  }, {
    path: "/:lang/news/payment-insights/taking-the-pain-out-of-payments-change",
    component: _6f74e943,
    name: "lang-news/payment-insights-taking-the-pain-out-of-payments-change"
  }, {
    path: "/:lang/news/payment-insights/how-sepa-indirect-participants-benefit-dnsp",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-sepa-indirect-participants-benefit-dnsp"
  }, {
    path: "/:lang/news/payment-insights/why-now-for-fednow-use-cases-for-rtp",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-now-for-fednow-use-cases-for-rtp"
  }, {
    path: "/:lang/news/payment-insights/gated-content-real-time-payments-implementation-lessons-from-across-the-pond1",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-real-time-payments-implementation-lessons-from-across-the-pond1"
  }, {
    path: "/:lang/news/payment-insights/gated-content-how-to-combat-financial-crime-through-data-sharing-and-collaboration",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-how-to-combat-financial-crime-through-data-sharing-and-collaboration"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-faster-payments-does-interoperability-matter",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-faster-payments-does-interoperability-matter"
  }, {
    path: "/:lang/news/payment-insights/big-banks-get-smart-or-smart-banks-get-big",
    component: _6f74e943,
    name: "lang-news/payment-insights-big-banks-get-smart-or-smart-banks-get-big"
  }, {
    path: "/:lang/news/payment-insights/fednow-and-rtp-the-question-of-interoperability",
    component: _6f74e943,
    name: "lang-news/payment-insights-fednow-and-rtp-the-question-of-interoperability"
  }, {
    path: "/:lang/news/payment-insights/gated-content-the-next-step-for-faster-payments-interoperability",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-the-next-step-for-faster-payments-interoperability"
  }, {
    path: "/:lang/news/payment-insights/fx-rates",
    component: _6f74e943,
    name: "lang-news/payment-insights-fx-rates"
  }, {
    path: "/:lang/news/payment-insights/what-is-technical-writing",
    component: _6f74e943,
    name: "lang-news/payment-insights-what-is-technical-writing"
  }, {
    path: "/:lang/news/payment-insights/leverage-the-power-of-international-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-leverage-the-power-of-international-payments"
  }, {
    path: "/:lang/news/payment-insights/2023-payment-predictions-for-us-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-2023-payment-predictions-for-us-banks"
  }, {
    path: "/:lang/news/payment-insights/confirmation-of-payee-scheme-extension-what-financial",
    component: _6f74e943,
    name: "lang-news/payment-insights-confirmation-of-payee-scheme-extension-what-financial"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-modernizing-payments-in-the-us",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-modernizing-payments-in-the-us"
  }, {
    path: "/:lang/news/payment-insights/faster-payments-and-real-time-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-faster-payments-and-real-time-payments"
  }, {
    path: "/:lang/news/payment-insights/growing-your-international-payments-business",
    component: _6f74e943,
    name: "lang-news/payment-insights-growing-your-international-payments-business"
  }, {
    path: "/:lang/news/payment-insights/why-banks-are-moving-to-a-platform-approach",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-banks-are-moving-to-a-platform-approach"
  }, {
    path: "/:lang/news/payment-insights/dora-cloud-regulation-for-banks-in-europe",
    component: _6f74e943,
    name: "lang-news/payment-insights-dora-cloud-regulation-for-banks-in-europe"
  }, {
    path: "/:lang/news/payment-insights/fostering-healthy-teams-at-form3",
    component: _6f74e943,
    name: "lang-news/payment-insights-fostering-healthy-teams-at-form3"
  }, {
    path: "/:lang/news/payment-insights/black-history-month-at-form3",
    component: _6f74e943,
    name: "lang-news/payment-insights-black-history-month-at-form3"
  }, {
    path: "/:lang/news/payment-insights/mandated-instant-payments-whatyoushoulknow",
    component: _6f74e943,
    name: "lang-news/payment-insights-mandated-instant-payments-whatyoushoulknow"
  }, {
    path: "/:lang/news/payment-insights/how-form3-holds-effective-meetings",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-form3-holds-effective-meetings"
  }, {
    path: "/:lang/news/payment-insights/us-payment-modernization-best-approaches-in-2022",
    component: _6f74e943,
    name: "lang-news/payment-insights-us-payment-modernization-best-approaches-in-2022"
  }, {
    path: "/:lang/news/payment-insights/its-all-about-communication",
    component: _6f74e943,
    name: "lang-news/payment-insights-its-all-about-communication"
  }, {
    path: "/:lang/news/payment-insights/gated-content-going-global-the-fundamentals-to-building-your-international-payments-business",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-going-global-the-fundamentals-to-building-your-international-payments-business"
  }, {
    path: "/:lang/news/payment-insights/gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention"
  }, {
    path: "/:lang/news/payment-insights/on-mental-health-as-a-manager",
    component: _6f74e943,
    name: "lang-news/payment-insights-on-mental-health-as-a-manager"
  }, {
    path: "/:lang/news/payment-insights/psychological-safety-at-form3",
    component: _6f74e943,
    name: "lang-news/payment-insights-psychological-safety-at-form3"
  }, {
    path: "/:lang/news/payment-insights/npa-technical-from-project-migration",
    component: _6f74e943,
    name: "lang-news/payment-insights-npa-technical-from-project-migration"
  }, {
    path: "/:lang/news/payment-insights/how-form3-is-supporting-its-teams-mental-health",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-form3-is-supporting-its-teams-mental-health"
  }, {
    path: "/:lang/news/payment-insights/gated-content-us-payment-landscape-the-modernization-journey",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-us-payment-landscape-the-modernization-journey"
  }, {
    path: "/:lang/news/payment-insights/industry-intelligence-why-multi-cloud-is-the-future",
    component: _6f74e943,
    name: "lang-news/payment-insights-industry-intelligence-why-multi-cloud-is-the-future"
  }, {
    path: "/:lang/news/payment-insights/industry-intelligence-how-neobanks-can-use-cross-currency",
    component: _6f74e943,
    name: "lang-news/payment-insights-industry-intelligence-how-neobanks-can-use-cross-currency"
  }, {
    path: "/:lang/news/payment-insights/keeping-connected-in-a-remote-first-business",
    component: _6f74e943,
    name: "lang-news/payment-insights-keeping-connected-in-a-remote-first-business"
  }, {
    path: "/:lang/news/payment-insights/case-study-nationwide-and-form3-on-migrating-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-case-study-nationwide-and-form3-on-migrating-payments"
  }, {
    path: "/:lang/news/payment-insights/form3-cares-about-the-planet",
    component: _6f74e943,
    name: "lang-news/payment-insights-form3-cares-about-the-planet"
  }, {
    path: "/:lang/news/payment-insights/gated-content-whitepaper-is-change-really-such-a-scary-word-digital",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-whitepaper-is-change-really-such-a-scary-word-digital"
  }, {
    path: "/:lang/news/payment-insights/gated-content-how-real-time-payments-are-solving-todays-problems-for-tomorrows-success",
    component: _6f74e943,
    name: "lang-news/payment-insights-gated-content-how-real-time-payments-are-solving-todays-problems-for-tomorrows-success"
  }, {
    path: "/:lang/news/payment-insights/fednow-what-you-need-to-know-before-2023",
    component: _6f74e943,
    name: "lang-news/payment-insights-fednow-what-you-need-to-know-before-2023"
  }, {
    path: "/:lang/news/payment-insights/this-is-why-we-live-in-a-golden-age-of-technology",
    component: _6f74e943,
    name: "lang-news/payment-insights-this-is-why-we-live-in-a-golden-age-of-technology"
  }, {
    path: "/:lang/news/payment-insights/why-cloud-native-is-key-for-fintechs-in-europe",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-cloud-native-is-key-for-fintechs-in-europe"
  }, {
    path: "/:lang/news/payment-insights/fintech-regulation-in-europe-challenges-and-new-roles",
    component: _6f74e943,
    name: "lang-news/payment-insights-fintech-regulation-in-europe-challenges-and-new-roles"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-new-payments-architecture-navigating-future",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-new-payments-architecture-navigating-future"
  }, {
    path: "/:lang/news/payment-insights/webinar-are-you-ready-for-the-next-stage-in-europes",
    component: _6f74e943,
    name: "lang-news/payment-insights-webinar-are-you-ready-for-the-next-stage-in-europes"
  }, {
    path: "/:lang/news/payment-insights/whats-top-of-mind-penny-hughes-column1",
    component: _6f74e943,
    name: "lang-news/payment-insights-whats-top-of-mind-penny-hughes-column1"
  }, {
    path: "/:lang/news/payment-insights/industry-advice-how-devops-can-drive-technological",
    component: _6f74e943,
    name: "lang-news/payment-insights-industry-advice-how-devops-can-drive-technological"
  }, {
    path: "/:lang/news/payment-insights/industry-advice-what-us-banks-need-to-know-about",
    component: _6f74e943,
    name: "lang-news/payment-insights-industry-advice-what-us-banks-need-to-know-about"
  }, {
    path: "/:lang/news/payment-insights/meet-form3s-esg-intern",
    component: _6f74e943,
    name: "lang-news/payment-insights-meet-form3s-esg-intern"
  }, {
    path: "/:lang/news/payment-insights/debunking-the-myths-of-open-source-software",
    component: _6f74e943,
    name: "lang-news/payment-insights-debunking-the-myths-of-open-source-software"
  }, {
    path: "/:lang/news/payment-insights/setting-our-team-up-for-successful-remote-work",
    component: _6f74e943,
    name: "lang-news/payment-insights-setting-our-team-up-for-successful-remote-work"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-the-future-of-fintech-disruption-in-europe",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-the-future-of-fintech-disruption-in-europe"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-how-cloud-powers-the-future-of-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-how-cloud-powers-the-future-of-payments"
  }, {
    path: "/:lang/news/payment-insights/our-culture-of-continuous-learning",
    component: _6f74e943,
    name: "lang-news/payment-insights-our-culture-of-continuous-learning"
  }, {
    path: "/:lang/news/payment-insights/whitepaper-born-in-the-cloud",
    component: _6f74e943,
    name: "lang-news/payment-insights-whitepaper-born-in-the-cloud"
  }, {
    path: "/:lang/news/payment-insights/instant-payments-in-europe",
    component: _6f74e943,
    name: "lang-news/payment-insights-instant-payments-in-europe"
  }, {
    path: "/:lang/news/payment-insights/form3s-approach-to-giving-back",
    component: _6f74e943,
    name: "lang-news/payment-insights-form3s-approach-to-giving-back"
  }, {
    path: "/:lang/news/payment-insights/npa-webinar",
    component: _6f74e943,
    name: "lang-news/payment-insights-npa-webinar"
  }, {
    path: "/:lang/news/payment-insights/whats-top-of-mind-penny-hughes-column",
    component: _6f74e943,
    name: "lang-news/payment-insights-whats-top-of-mind-penny-hughes-column"
  }, {
    path: "/:lang/news/payment-insights/industry-advice-how-to-plan-for-the-new-payments-architecture",
    component: _6f74e943,
    name: "lang-news/payment-insights-industry-advice-how-to-plan-for-the-new-payments-architecture"
  }, {
    path: "/:lang/news/payment-insights/international-womens-day-spotlight-the-life-of-a-technology-evangelist",
    component: _6f74e943,
    name: "lang-news/payment-insights-international-womens-day-spotlight-the-life-of-a-technology-evangelist"
  }, {
    path: "/:lang/news/payment-insights/male-allies-at-form3-on-international-womens-day",
    component: _6f74e943,
    name: "lang-news/payment-insights-male-allies-at-form3-on-international-womens-day"
  }, {
    path: "/:lang/news/payment-insights/asynchronous-communication-at-form3",
    component: _6f74e943,
    name: "lang-news/payment-insights-asynchronous-communication-at-form3"
  }, {
    path: "/:lang/news/payment-insights/form3-diversity-update---a-year-in-review",
    component: _6f74e943,
    name: "lang-news/payment-insights-form3-diversity-update---a-year-in-review"
  }, {
    path: "/:lang/news/payment-insights/form3s-first-apprentice",
    component: _6f74e943,
    name: "lang-news/payment-insights-form3s-first-apprentice"
  }, {
    path: "/:lang/news/payment-insights/lessons-learned-from-europe",
    component: _6f74e943,
    name: "lang-news/payment-insights-lessons-learned-from-europe"
  }, {
    path: "/:lang/news/payment-insights/you-may-be-iso-to-the-core-but-the-form3-platform-is-still-your-best-gateway-option",
    component: _6f74e943,
    name: "lang-news/payment-insights-you-may-be-iso-to-the-core-but-the-form3-platform-is-still-your-best-gateway-option"
  }, {
    path: "/:lang/news/payment-insights/how-microservices-are-changing-the-game-for-operational-resilience-and-cyber-security-in-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-microservices-are-changing-the-game-for-operational-resilience-and-cyber-security-in-payments"
  }, {
    path: "/:lang/news/payment-insights/why-cloud-payment-processing-is-the-answer-to-scaling-challenges-at-banks",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-cloud-payment-processing-is-the-answer-to-scaling-challenges-at-banks"
  }, {
    path: "/:lang/news/payment-insights/why-enterprise-banks-must-adopt-innovations-in-payment-technologies",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-enterprise-banks-must-adopt-innovations-in-payment-technologies"
  }, {
    path: "/:lang/news/payment-insights/why-corporate-treasurers-should-care-about-the-tech-their-banks-are-using",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-corporate-treasurers-should-care-about-the-tech-their-banks-are-using"
  }, {
    path: "/:lang/news/payment-insights/confirmation-of-payee-opportunity-or-headache",
    component: _6f74e943,
    name: "lang-news/payment-insights-confirmation-of-payee-opportunity-or-headache"
  }, {
    path: "/:lang/news/payment-insights/minimising-the-risk-of-transforming-core-payments-technology---a-form3-perspective",
    component: _6f74e943,
    name: "lang-news/payment-insights-minimising-the-risk-of-transforming-core-payments-technology---a-form3-perspective"
  }, {
    path: "/:lang/news/payment-insights/the-key-to-open-bankings-success-global-adoption-of-real-time-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-the-key-to-open-bankings-success-global-adoption-of-real-time-payments"
  }, {
    path: "/:lang/news/payment-insights/female-leadership-spotlight--penny-hughes",
    component: _6f74e943,
    name: "lang-news/payment-insights-female-leadership-spotlight--penny-hughes"
  }, {
    path: "/:lang/news/payment-insights/female-leadership-spotlight---eimear-oconnor",
    component: _6f74e943,
    name: "lang-news/payment-insights-female-leadership-spotlight---eimear-oconnor"
  }, {
    path: "/:lang/news/payment-insights/your-guide-to-selecting-the-right-payments-technology-partner",
    component: _6f74e943,
    name: "lang-news/payment-insights-your-guide-to-selecting-the-right-payments-technology-partner"
  }, {
    path: "/:lang/news/payment-insights/female-leadership-spotlight---bonnie-mitchell",
    component: _6f74e943,
    name: "lang-news/payment-insights-female-leadership-spotlight---bonnie-mitchell"
  }, {
    path: "/:lang/news/payment-insights/how-to-effectively-run-payment-transformation-programmes-with-banks-in-a-fully-remote-environment",
    component: _6f74e943,
    name: "lang-news/payment-insights-how-to-effectively-run-payment-transformation-programmes-with-banks-in-a-fully-remote-environment"
  }, {
    path: "/:lang/news/payment-insights/why-financial-institutions-are-banking-on-cloud-native-technology-to-stay-competitive",
    component: _6f74e943,
    name: "lang-news/payment-insights-why-financial-institutions-are-banking-on-cloud-native-technology-to-stay-competitive"
  }, {
    path: "/:lang/news/payment-insights/utilising-pair-programming-in-a-100-remote-environment",
    component: _6f74e943,
    name: "lang-news/payment-insights-utilising-pair-programming-in-a-100-remote-environment"
  }, {
    path: "/:lang/news/payment-insights/managing-and-leading-transformational-change-projects-at-a-fast-growing-fintech",
    component: _6f74e943,
    name: "lang-news/payment-insights-managing-and-leading-transformational-change-projects-at-a-fast-growing-fintech"
  }, {
    path: "/:lang/news/payment-insights/what-the-hack",
    component: _6f74e943,
    name: "lang-news/payment-insights-what-the-hack"
  }, {
    path: "/:lang/news/payment-insights/accelerating-innovation-in-financial-services",
    component: _6f74e943,
    name: "lang-news/payment-insights-accelerating-innovation-in-financial-services"
  }, {
    path: "/:lang/news/payment-insights/international-womens-day",
    component: _6f74e943,
    name: "lang-news/payment-insights-international-womens-day"
  }, {
    path: "/:lang/news/payment-insights/a-remote-first-culture",
    component: _6f74e943,
    name: "lang-news/payment-insights-a-remote-first-culture"
  }, {
    path: "/:lang/news/payment-insights/building-connections",
    component: _6f74e943,
    name: "lang-news/payment-insights-building-connections"
  }, {
    path: "/:lang/news/payment-insights/raising-our-standards",
    component: _6f74e943,
    name: "lang-news/payment-insights-raising-our-standards"
  }, {
    path: "/:lang/news/payment-insights/bridging-the-divide",
    component: _6f74e943,
    name: "lang-news/payment-insights-bridging-the-divide"
  }, {
    path: "/:lang/news/payment-insights/back-to-the-future",
    component: _6f74e943,
    name: "lang-news/payment-insights-back-to-the-future"
  }, {
    path: "/:lang/news/payment-insights/the-great-divide",
    component: _6f74e943,
    name: "lang-news/payment-insights-the-great-divide"
  }, {
    path: "/:lang/news/payment-insights/payments-dna",
    component: _6f74e943,
    name: "lang-news/payment-insights-payments-dna"
  }, {
    path: "/:lang/news/payment-insights/game-changers",
    component: _6f74e943,
    name: "lang-news/payment-insights-game-changers"
  }, {
    path: "/:lang/news/payment-insights/nowhere-to-hide",
    component: _6f74e943,
    name: "lang-news/payment-insights-nowhere-to-hide"
  }, {
    path: "/:lang/news/payment-insights/standards--old-problems-new-solutions",
    component: _6f74e943,
    name: "lang-news/payment-insights-standards--old-problems-new-solutions"
  }, {
    path: "/:lang/news/payment-insights/new-payments-architecture",
    component: _6f74e943,
    name: "lang-news/payment-insights-new-payments-architecture"
  }, {
    path: "/:lang/news/payment-insights/hyper-automation-in-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-hyper-automation-in-payments"
  }, {
    path: "/:lang/news/payment-insights/women-in-tech",
    component: _6f74e943,
    name: "lang-news/payment-insights-women-in-tech"
  }, {
    path: "/:lang/news/payment-insights/real-time-is-becoming-the-new-normal-in-payments",
    component: _6f74e943,
    name: "lang-news/payment-insights-real-time-is-becoming-the-new-normal-in-payments"
  }, {
    path: "/:lang/news/payment-insights/will-all-banks-and-psps-require-their-own-sort-code-from-july-2019",
    component: _6f74e943,
    name: "lang-news/payment-insights-will-all-banks-and-psps-require-their-own-sort-code-from-july-2019"
  }, {
    path: "/:lang/blog/engineering/dangling-danger",
    component: _52c85e91,
    name: "lang-blog/engineering-dangling-danger"
  }, {
    path: "/:lang/blog/engineering/five-ws-incident-mngmnt",
    component: _52c85e91,
    name: "lang-blog/engineering-five-ws-incident-mngmnt"
  }, {
    path: "/:lang/blog/engineering/podcast-conf-speaking",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-conf-speaking"
  }, {
    path: "/:lang/blog/engineering/blog-decision-making",
    component: _52c85e91,
    name: "lang-blog/engineering-blog-decision-making"
  }, {
    path: "/:lang/blog/engineering/incident-mngmnt-devops",
    component: _52c85e91,
    name: "lang-blog/engineering-incident-mngmnt-devops"
  }, {
    path: "/:lang/blog/engineering/podcast-whats-new-nats",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-whats-new-nats"
  }, {
    path: "/:lang/blog/engineering/customers-incidents-prometheus",
    component: _52c85e91,
    name: "lang-blog/engineering-customers-incidents-prometheus"
  }, {
    path: "/:lang/blog/engineering/podcast-containers",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-containers"
  }, {
    path: "/:lang/blog/engineering/packets-aws-gateway-load",
    component: _52c85e91,
    name: "lang-blog/engineering-packets-aws-gateway-load"
  }, {
    path: "/:lang/blog/engineering/secrets-build-pipelines",
    component: _52c85e91,
    name: "lang-blog/engineering-secrets-build-pipelines"
  }, {
    path: "/:lang/blog/engineering/podcast-ext-secrets",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-ext-secrets"
  }, {
    path: "/:lang/blog/engineering/life-of-incident-mngr",
    component: _52c85e91,
    name: "lang-blog/engineering-life-of-incident-mngr"
  }, {
    path: "/:lang/blog/engineering/blog-bootstrapping-engineering-org",
    component: _52c85e91,
    name: "lang-blog/engineering-blog-bootstrapping-engineering-org"
  }, {
    path: "/:lang/blog/engineering/podcast-idp",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-idp"
  }, {
    path: "/:lang/blog/engineering/intro-ethical-hacking",
    component: _52c85e91,
    name: "lang-blog/engineering-intro-ethical-hacking"
  }, {
    path: "/:lang/blog/engineering/migrating-gh-boards",
    component: _52c85e91,
    name: "lang-blog/engineering-migrating-gh-boards"
  }, {
    path: "/:lang/blog/engineering/podcast-landing-remote-job",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-landing-remote-job"
  }, {
    path: "/:lang/blog/engineering/phishing-github",
    component: _52c85e91,
    name: "lang-blog/engineering-phishing-github"
  }, {
    path: "/:lang/blog/engineering/first-month-swe",
    component: _52c85e91,
    name: "lang-blog/engineering-first-month-swe"
  }, {
    path: "/:lang/blog/engineering/podcast-async-reviews",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-async-reviews"
  }, {
    path: "/:lang/blog/engineering/electron-injection",
    component: _52c85e91,
    name: "lang-blog/engineering-electron-injection"
  }, {
    path: "/:lang/blog/engineering/podcast-build-multicloud",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-build-multicloud"
  }, {
    path: "/:lang/blog/engineering/starting-new-project",
    component: _52c85e91,
    name: "lang-blog/engineering-starting-new-project"
  }, {
    path: "/:lang/blog/engineering/how-to-find-and-fix-memory-leaks-in-go-applications",
    component: _52c85e91,
    name: "lang-blog/engineering-how-to-find-and-fix-memory-leaks-in-go-applications"
  }, {
    path: "/:lang/blog/engineering/podcast-remote-work",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-remote-work"
  }, {
    path: "/:lang/blog/engineering/nacls-blogpost",
    component: _52c85e91,
    name: "lang-blog/engineering-nacls-blogpost"
  }, {
    path: "/:lang/blog/engineering/buckle-up-your-mtls-with-oauth-2-0-client-authentication",
    component: _52c85e91,
    name: "lang-blog/engineering-buckle-up-your-mtls-with-oauth-2-0-client-authentication"
  }, {
    path: "/:lang/blog/engineering/exploiting-distroless-images",
    component: _52c85e91,
    name: "lang-blog/engineering-exploiting-distroless-images"
  }, {
    path: "/:lang/blog/engineering/podcast-k8s-robusta",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-k8s-robusta"
  }, {
    path: "/:lang/blog/engineering/podcast-engineering-success",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-engineering-success"
  }, {
    path: "/:lang/blog/engineering/pki-cert-management",
    component: _52c85e91,
    name: "lang-blog/engineering-pki-cert-management"
  }, {
    path: "/:lang/blog/engineering/podcast-supporting-diversity",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-supporting-diversity"
  }, {
    path: "/:lang/blog/engineering/dylib-injection-in-golang-apps",
    component: _52c85e91,
    name: "lang-blog/engineering-dylib-injection-in-golang-apps"
  }, {
    path: "/:lang/blog/engineering/linux-fundamentals-user-kernel-space",
    component: _52c85e91,
    name: "lang-blog/engineering-linux-fundamentals-user-kernel-space"
  }, {
    path: "/:lang/blog/engineering/podcast-evolving-apis",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-evolving-apis"
  }, {
    path: "/:lang/blog/engineering/bypassing-ebpf-tools",
    component: _52c85e91,
    name: "lang-blog/engineering-bypassing-ebpf-tools"
  }, {
    path: "/:lang/blog/engineering/podcast-careers-engineering",
    component: _52c85e91,
    name: "lang-blog/engineering-podcast-careers-engineering"
  }, {
    path: "/:lang/blog/engineering/testing-at-form3",
    component: _52c85e91,
    name: "lang-blog/engineering-testing-at-form3"
  }, {
    path: "/:lang/blog/engineering/nat-and-proxies-part2",
    component: _52c85e91,
    name: "lang-blog/engineering-nat-and-proxies-part2"
  }, {
    path: "/:lang/blog/engineering/nat-and-proxies-part-1",
    component: _52c85e91,
    name: "lang-blog/engineering-nat-and-proxies-part-1"
  }, {
    path: "/:lang/blog/engineering/security-scanning-using-tfsec",
    component: _52c85e91,
    name: "lang-blog/engineering-security-scanning-using-tfsec"
  }, {
    path: "/:lang/blog/engineering/running-elk-locally-to-interrogate-container-logs",
    component: _52c85e91,
    name: "lang-blog/engineering-running-elk-locally-to-interrogate-container-logs"
  }, {
    path: "/:lang/blog/engineering/infrastructure-as-code-to-control-access-to-everything",
    component: _52c85e91,
    name: "lang-blog/engineering-infrastructure-as-code-to-control-access-to-everything"
  }, {
    path: "/:lang/blog/engineering/conf42-golang-2022-load-testing-with-f1",
    component: _52c85e91,
    name: "lang-blog/engineering-conf42-golang-2022-load-testing-with-f1"
  }, {
    path: "/:lang/blog/engineering/delivering-at-scale-for-meta",
    component: _52c85e91,
    name: "lang-blog/engineering-delivering-at-scale-for-meta"
  }, {
    path: "/:lang/blog/engineering/ep27-podcast",
    component: _52c85e91,
    name: "lang-blog/engineering-ep27-podcast"
  }, {
    path: "/:lang/blog/engineering/prometheus-histograms",
    component: _52c85e91,
    name: "lang-blog/engineering-prometheus-histograms"
  }, {
    path: "/:lang/blog/engineering/ep26-podcast",
    component: _52c85e91,
    name: "lang-blog/engineering-ep26-podcast"
  }, {
    path: "/:lang/blog/engineering/ep25-podcast",
    component: _52c85e91,
    name: "lang-blog/engineering-ep25-podcast"
  }, {
    path: "/:lang/blog/engineering/ep24-podcast",
    component: _52c85e91,
    name: "lang-blog/engineering-ep24-podcast"
  }, {
    path: "/:lang/blog/engineering/ep23-podcast",
    component: _52c85e91,
    name: "lang-blog/engineering-ep23-podcast"
  }, {
    path: "/:lang/blog/engineering/millions-payments-haproxy",
    component: _52c85e91,
    name: "lang-blog/engineering-millions-payments-haproxy"
  }, {
    path: "/:lang/blog/engineering/ep22-podcast",
    component: _52c85e91,
    name: "lang-blog/engineering-ep22-podcast"
  }, {
    path: "/:lang/blog/engineering/conf42-code-insight",
    component: _52c85e91,
    name: "lang-blog/engineering-conf42-code-insight"
  }, {
    path: "/:lang/blog/engineering/gophercon-elastic",
    component: _52c85e91,
    name: "lang-blog/engineering-gophercon-elastic"
  }, {
    path: "/:lang/blog/engineering/gophercon-nats",
    component: _52c85e91,
    name: "lang-blog/engineering-gophercon-nats"
  }, {
    path: "/:lang/blog/engineering/remote-pair-programming",
    component: _52c85e91,
    name: "lang-blog/engineering-remote-pair-programming"
  }, {
    path: "/:lang/engineering/who-we-are/open-source",
    component: _7ab26e2a,
    name: "lang-engineering/who-we-are-open-source"
  }, {
    path: "/:lang/engineering/who-we-are/tech-stack",
    component: _7ab26e2a,
    name: "lang-engineering/who-we-are-tech-stack"
  }, {
    path: "/:lang/campaigns/first-campaign-post",
    component: _38407230,
    name: "lang-campaigns-first-campaign-post"
  }, {
    path: "/:lang/campaigns/npa-webinar-1",
    component: _38407230,
    name: "lang-campaigns-npa-webinar-1"
  }, {
    path: "/:lang/campaigns/re-platforming-critical-payments-infrastructure-to",
    component: _38407230,
    name: "lang-campaigns-re-platforming-critical-payments-infrastructure-to"
  }, {
    path: "/:lang/campaigns/instant-payments-in-europe-where-next",
    component: _38407230,
    name: "lang-campaigns-instant-payments-in-europe-where-next"
  }, {
    path: "/:lang/campaigns/the-future-of-fintech-disruption-in-europe",
    component: _38407230,
    name: "lang-campaigns-the-future-of-fintech-disruption-in-europe"
  }, {
    path: "/:lang/campaigns/download-how-cloud-powers-the-future-of-payments",
    component: _38407230,
    name: "lang-campaigns-download-how-cloud-powers-the-future-of-payments"
  }, {
    path: "/:lang/campaigns/european-payment-evolution-22",
    component: _38407230,
    name: "lang-campaigns-european-payment-evolution-22"
  }, {
    path: "/:lang/campaigns/new-payments-architecture-navigating-future-access",
    component: _38407230,
    name: "lang-campaigns-new-payments-architecture-navigating-future-access"
  }, {
    path: "/:lang/campaigns/is-change-really-such-a-scary-word-digital-disruption",
    component: _38407230,
    name: "lang-campaigns-is-change-really-such-a-scary-word-digital-disruption"
  }, {
    path: "/:lang/campaigns/gated-content-tomorrows-problems-for-todays-success",
    component: _38407230,
    name: "lang-campaigns-gated-content-tomorrows-problems-for-todays-success"
  }, {
    path: "/:lang/campaigns/gated-content-us-payment-landscape-the-modernization-journey",
    component: _38407230,
    name: "lang-campaigns-gated-content-us-payment-landscape-the-modernization-journey"
  }, {
    path: "/:lang/campaigns/gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention",
    component: _38407230,
    name: "lang-campaigns-gated-content-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention"
  }, {
    path: "/:lang/campaigns/gated-content-going-global-the-fundamentals-to-building-your-international-payments-business",
    component: _38407230,
    name: "lang-campaigns-gated-content-going-global-the-fundamentals-to-building-your-international-payments-business"
  }, {
    path: "/:lang/campaigns/gated-content-international-services-webinar",
    component: _38407230,
    name: "lang-campaigns-gated-content-international-services-webinar"
  }, {
    path: "/:lang/campaigns/gated-content-sepa-services-webinar2",
    component: _38407230,
    name: "lang-campaigns-gated-content-sepa-services-webinar2"
  }, {
    path: "/:lang/campaigns/gated-content-uk-payments-services",
    component: _38407230,
    name: "lang-campaigns-gated-content-uk-payments-services"
  }, {
    path: "/:lang/campaigns/gated-content-modernizing-payments-in-the-us",
    component: _38407230,
    name: "lang-campaigns-gated-content-modernizing-payments-in-the-us"
  }, {
    path: "/:lang/campaigns/partners-multicloud-webinar",
    component: _38407230,
    name: "lang-campaigns-partners-multicloud-webinar"
  }, {
    path: "/:lang/campaigns/partners-us-payments-services-webinar",
    component: _38407230,
    name: "lang-campaigns-partners-us-payments-services-webinar"
  }, {
    path: "/:lang/campaigns/gated-content-video-the-next-step-for-faster-payments-interoperability",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-the-next-step-for-faster-payments-interoperability"
  }, {
    path: "/:lang/campaigns/gated-content-sepa-instant-factsheet",
    component: _38407230,
    name: "lang-campaigns-gated-content-sepa-instant-factsheet"
  }, {
    path: "/:lang/campaigns/gated-content-instant-has-been-mandated-will-you-be-ready-for-it",
    component: _38407230,
    name: "lang-campaigns-gated-content-instant-has-been-mandated-will-you-be-ready-for-it"
  }, {
    path: "/:lang/campaigns/gated-content-faster-payments-does-interoperability-matter",
    component: _38407230,
    name: "lang-campaigns-gated-content-faster-payments-does-interoperability-matter"
  }, {
    path: "/:lang/campaigns/gated-content-video-the-next-step-for-faster-payments-interoperability1",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-the-next-step-for-faster-payments-interoperability1"
  }, {
    path: "/:lang/campaigns/gated-content-meeting-the-challenges-of-the-uks-new-payment-architecture",
    component: _38407230,
    name: "lang-campaigns-gated-content-meeting-the-challenges-of-the-uks-new-payment-architecture"
  }, {
    path: "/:lang/campaigns/gated-content-video-international-payments-build-buy-or-both",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-international-payments-build-buy-or-both"
  }, {
    path: "/:lang/campaigns/gated-content-video-why-now-for-fednow",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-why-now-for-fednow"
  }, {
    path: "/:lang/campaigns/comprehensive-guide-to-new-payments-architecture",
    component: _38407230,
    name: "lang-campaigns-comprehensive-guide-to-new-payments-architecture"
  }, {
    path: "/:lang/campaigns/gated-content-data-sharing-to-prevent-economic-crime",
    component: _38407230,
    name: "lang-campaigns-gated-content-data-sharing-to-prevent-economic-crime"
  }, {
    path: "/:lang/campaigns/gated-content-video-decoding-the-sepa-instant-mandate",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-decoding-the-sepa-instant-mandate"
  }, {
    path: "/:lang/campaigns/gated-content-leading-european-psp-achieve-rapid-expansion",
    component: _38407230,
    name: "lang-campaigns-gated-content-leading-european-psp-achieve-rapid-expansion"
  }, {
    path: "/:lang/campaigns/gated-content-video-navigating-integration-and-resilience-of-new-payment-schemes",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-navigating-integration-and-resilience-of-new-payment-schemes"
  }, {
    path: "/:lang/campaigns/gated-content-uk-faster-payments-a-model-for-us-banks",
    component: _38407230,
    name: "lang-campaigns-gated-content-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/:lang/campaigns/gated-content-video-rethinking-testing-strategies-for-real-time-payments",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-rethinking-testing-strategies-for-real-time-payments"
  }, {
    path: "/:lang/campaigns/gated-content-from-cloud-to-multicloud-a-pathway-to-resilience",
    component: _38407230,
    name: "lang-campaigns-gated-content-from-cloud-to-multicloud-a-pathway-to-resilience"
  }, {
    path: "/:lang/campaigns/gated-content-video-how-apis-are-reshaping-the-payments-landscape",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-how-apis-are-reshaping-the-payments-landscape"
  }, {
    path: "/:lang/campaigns/gated-content-video-interoperability-global-instant-schemes",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-interoperability-global-instant-schemes"
  }, {
    path: "/:lang/campaigns/gated-content-advancing-payment-innovation",
    component: _38407230,
    name: "lang-campaigns-gated-content-advancing-payment-innovation"
  }, {
    path: "/:lang/campaigns/gated-content-video-unleash-the-power-of-iso-20022",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-unleash-the-power-of-iso-20022"
  }, {
    path: "/:lang/campaigns/gated-content-video-demystifying-payment-modernization-separating-fact-from-fiction",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-demystifying-payment-modernization-separating-fact-from-fiction"
  }, {
    path: "/:lang/campaigns/gated-content-video-webinar-pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-webinar-pymnts-tough-questions-taking-a-proactive-approach-to-instant-payments-risks-and-rewards"
  }, {
    path: "/:lang/campaigns/navigating-the-digital-shift-download-2",
    component: _38407230,
    name: "lang-campaigns-navigating-the-digital-shift-download-2"
  }, {
    path: "/:lang/campaigns/navigating-the-digital-shift-download-3",
    component: _38407230,
    name: "lang-campaigns-navigating-the-digital-shift-download-3"
  }, {
    path: "/:lang/campaigns/download-navigating-the-digital-shift-final",
    component: _38407230,
    name: "lang-campaigns-download-navigating-the-digital-shift-final"
  }, {
    path: "/:lang/campaigns/rethinking-a-platform-approach-to-payments",
    component: _38407230,
    name: "lang-campaigns-rethinking-a-platform-approach-to-payments"
  }, {
    path: "/:lang/campaigns/gated-content-video-real-time-payments-implementation-lessons-from-across-the-pond",
    component: _38407230,
    name: "lang-campaigns-gated-content-video-real-time-payments-implementation-lessons-from-across-the-pond"
  }, {
    path: "/:lang/campaigns/why-orchestration-is-key-for-payment-modernization",
    component: _38407230,
    name: "lang-campaigns-why-orchestration-is-key-for-payment-modernization"
  }, {
    path: "/:lang/campaigns/why-orchestration-is-key-for-payment-modernization-download",
    component: _38407230,
    name: "lang-campaigns-why-orchestration-is-key-for-payment-modernization-download"
  }, {
    path: "/:lang/campaigns/download-navigating-the-fedwire-migration-to-iso-20022",
    component: _38407230,
    name: "lang-campaigns-download-navigating-the-fedwire-migration-to-iso-20022"
  }, {
    path: "/:lang/campaigns/datos-download",
    component: _38407230,
    name: "lang-campaigns-datos-download"
  }, {
    path: "/:lang/campaigns/nationwide-and-form3",
    component: _38407230,
    name: "lang-campaigns-nationwide-and-form3"
  }, {
    path: "/:lang/campaigns/harnessing-instant-payments-in-the-us-with-the-rtp-network",
    component: _38407230,
    name: "lang-campaigns-harnessing-instant-payments-in-the-us-with-the-rtp-network"
  }, {
    path: "/:lang/landing/test-landing-post",
    component: _459eabdc,
    name: "lang-landing-test-landing-post"
  }, {
    path: "/:lang/landing/whitepaper-born-in-the-cloud",
    component: _459eabdc,
    name: "lang-landing-whitepaper-born-in-the-cloud"
  }, {
    path: "/:lang/landing/whitepaper-instant-payments-in-europe-where-next",
    component: _459eabdc,
    name: "lang-landing-whitepaper-instant-payments-in-europe-where-next"
  }, {
    path: "/:lang/landing/download-the-whitepaper-the-future-of-fintech-disruption",
    component: _459eabdc,
    name: "lang-landing-download-the-whitepaper-the-future-of-fintech-disruption"
  }, {
    path: "/:lang/landing/whitepaper-how-cloud-powers-the-future-of-payments",
    component: _459eabdc,
    name: "lang-landing-whitepaper-how-cloud-powers-the-future-of-payments"
  }, {
    path: "/:lang/landing/download-the-whitepaper-new-payments-architecture-navigating-future-access-models",
    component: _459eabdc,
    name: "lang-landing-download-the-whitepaper-new-payments-architecture-navigating-future-access-models"
  }, {
    path: "/:lang/landing/download-the-whitepaper-is-change-really-such-a-scary",
    component: _459eabdc,
    name: "lang-landing-download-the-whitepaper-is-change-really-such-a-scary"
  }, {
    path: "/:lang/landing/gated-content-download-the-whitepaper-todays-problems-for-tomorrows-success",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-whitepaper-todays-problems-for-tomorrows-success"
  }, {
    path: "/:lang/landing/gated-content-download-the-whitepaper-meeting-the-challenges-of-the-uks-new-payment-architecture",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-whitepaper-meeting-the-challenges-of-the-uks-new-payment-architecture"
  }, {
    path: "/:lang/landing/women-who-go-london",
    component: _459eabdc,
    name: "lang-landing-women-who-go-london"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-us-payment-landscape-the-modernization-journey",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-us-payment-landscape-the-modernization-journey"
  }, {
    path: "/:lang/landing/whats-top-of-mind-penny-hughes-column",
    component: _459eabdc,
    name: "lang-landing-whats-top-of-mind-penny-hughes-column"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-confirmation-of-payee-cop-the-second-chapter-what-phase-2-means-for-financial-firms-and-the-future-of-fraud-prevention"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-going-global-the-fundamentals-to-building-your-international-payments-business",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-going-global-the-fundamentals-to-building-your-international-payments-business"
  }, {
    path: "/:lang/landing/payment-platform-us-us-instant-instant101",
    component: _459eabdc,
    name: "lang-landing-payment-platform-us-us-instant-instant101"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-modernizing-payments-in-the-us",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-modernizing-payments-in-the-us"
  }, {
    path: "/:lang/landing/delivering-payments-innovation-and-efficiency-during-challenging-times",
    component: _459eabdc,
    name: "lang-landing-delivering-payments-innovation-and-efficiency-during-challenging-times"
  }, {
    path: "/:lang/landing/looking-back-at-2022-looking-forward-to-2023",
    component: _459eabdc,
    name: "lang-landing-looking-back-at-2022-looking-forward-to-2023"
  }, {
    path: "/:lang/landing/payment-platform-us-us-wires101",
    component: _459eabdc,
    name: "lang-landing-payment-platform-us-us-wires101"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-the-next-step-for-faster-payments-interoperability",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-the-next-step-for-faster-payments-interoperability"
  }, {
    path: "/:lang/landing/gated-content-download-the-factsheet-instant-has-been-mandated-will-you-be-ready-for-it",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-factsheet-instant-has-been-mandated-will-you-be-ready-for-it"
  }, {
    path: "/:lang/landing/form3-insights-series",
    component: _459eabdc,
    name: "lang-landing-form3-insights-series"
  }, {
    path: "/:lang/landing/gated-content-download-the-whitepaper-faster-payments-does-interoperability-matter",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-whitepaper-faster-payments-does-interoperability-matter"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-international-payments-build-buy-or-both",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-international-payments-build-buy-or-both"
  }, {
    path: "/:lang/landing/economic-crime-congress",
    component: _459eabdc,
    name: "lang-landing-economic-crime-congress"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-why-now-for-fednow",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-why-now-for-fednow"
  }, {
    path: "/:lang/landing/why-our-people-are-driving-form3s-success",
    component: _459eabdc,
    name: "lang-landing-why-our-people-are-driving-form3s-success"
  }, {
    path: "/:lang/landing/preparing-for-market-changes-across-the-payments-landscape",
    component: _459eabdc,
    name: "lang-landing-preparing-for-market-changes-across-the-payments-landscape"
  }, {
    path: "/:lang/landing/gated-content-download-the-whitepaper-data-sharing-to-prevent-economic-crime",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-whitepaper-data-sharing-to-prevent-economic-crime"
  }, {
    path: "/:lang/landing/baft-2023",
    component: _459eabdc,
    name: "lang-landing-baft-2023"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-decoding-the-sepa-instant-mandate",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-decoding-the-sepa-instant-mandate"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-navigating-integration-and-resilience-of-new-payment-schemes",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-navigating-integration-and-resilience-of-new-payment-schemes"
  }, {
    path: "/:lang/landing/gated-content-download-the-whitepaper-uk-faster-payments-a-model-for-us-banks",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-whitepaper-uk-faster-payments-a-model-for-us-banks"
  }, {
    path: "/:lang/landing/gated-content-download-the-case-study",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-case-study"
  }, {
    path: "/:lang/landing/gated-content-download-the-linkedlnlive-rethinking-testing-strategies-for-real-time-payments",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-linkedlnlive-rethinking-testing-strategies-for-real-time-payments"
  }, {
    path: "/:lang/landing/gated-content-download-the-report-from-cloud-to-multicloud-a-pathway-to-resilience",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-report-from-cloud-to-multicloud-a-pathway-to-resilience"
  }, {
    path: "/:lang/landing/partnerships-key-to-modernising-payments-infrastructure",
    component: _459eabdc,
    name: "lang-landing-partnerships-key-to-modernising-payments-infrastructure"
  }, {
    path: "/:lang/landing/sandbox-testing-for-rtp-and-fednow-in-2023",
    component: _459eabdc,
    name: "lang-landing-sandbox-testing-for-rtp-and-fednow-in-2023"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-how-apis-are-reshaping-the-payments-landscape",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-how-apis-are-reshaping-the-payments-landscape"
  }, {
    path: "/:lang/landing/gated-content-download-the-livestream-interoperability",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-livestream-interoperability"
  }, {
    path: "/:lang/landing/why-we-are-setting-a-new-standard1",
    component: _459eabdc,
    name: "lang-landing-why-we-are-setting-a-new-standard1"
  }, {
    path: "/:lang/landing/gated-content-download-the-whitepaper-advancing-payment-innovation",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-whitepaper-advancing-payment-innovation"
  }, {
    path: "/:lang/landing/why-we-are-setting-a-new-standard",
    component: _459eabdc,
    name: "lang-landing-why-we-are-setting-a-new-standard"
  }, {
    path: "/:lang/landing/transform-your-payments-landscape",
    component: _459eabdc,
    name: "lang-landing-transform-your-payments-landscape"
  }, {
    path: "/:lang/landing/multicloud-for-payment-resilience",
    component: _459eabdc,
    name: "lang-landing-multicloud-for-payment-resilience"
  }, {
    path: "/:lang/landing/payment-platforms-power-innovation",
    component: _459eabdc,
    name: "lang-landing-payment-platforms-power-innovation"
  }, {
    path: "/:lang/landing/sibos-2023-fednow-takes-centre-stage",
    component: _459eabdc,
    name: "lang-landing-sibos-2023-fednow-takes-centre-stage"
  }, {
    path: "/:lang/landing/form3-operations-big-progress-a-major-partnership-new-leadership",
    component: _459eabdc,
    name: "lang-landing-form3-operations-big-progress-a-major-partnership-new-leadership"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-unleash-the-power-of-iso-20022",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-unleash-the-power-of-iso-20022"
  }, {
    path: "/:lang/landing/question-and-answer-unleash-the-power-of-iso-20022",
    component: _459eabdc,
    name: "lang-landing-question-and-answer-unleash-the-power-of-iso-20022"
  }, {
    path: "/:lang/landing/contact-blog",
    component: _459eabdc,
    name: "lang-landing-contact-blog"
  }, {
    path: "/:lang/landing/how-form3s-positive-progress-in-2023-will-continue-this-year",
    component: _459eabdc,
    name: "lang-landing-how-form3s-positive-progress-in-2023-will-continue-this-year"
  }, {
    path: "/:lang/landing/what-are-the-key-trends-in-payments-in-2024",
    component: _459eabdc,
    name: "lang-landing-what-are-the-key-trends-in-payments-in-2024"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-demystifying-payment-modernization-separating-fact-from-fiction",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-demystifying-payment-modernization-separating-fact-from-fiction"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-pymnts-taking-a-proactive-approach-to-instant-payments-risks-and-rewards",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-pymnts-taking-a-proactive-approach-to-instant-payments-risks-and-rewards"
  }, {
    path: "/:lang/landing/gated-content-download-the-whitepaper-navigating-the-digital-shift",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-whitepaper-navigating-the-digital-shift"
  }, {
    path: "/:lang/landing/navigating-the-digital-shift-form-2",
    component: _459eabdc,
    name: "lang-landing-navigating-the-digital-shift-form-2"
  }, {
    path: "/:lang/landing/navigating-the-digital-shift-form-3",
    component: _459eabdc,
    name: "lang-landing-navigating-the-digital-shift-form-3"
  }, {
    path: "/:lang/landing/navigating-the-digital-shift-final",
    component: _459eabdc,
    name: "lang-landing-navigating-the-digital-shift-final"
  }, {
    path: "/:lang/landing/changing-times-for-the-uk-payments-landscape",
    component: _459eabdc,
    name: "lang-landing-changing-times-for-the-uk-payments-landscape"
  }, {
    path: "/:lang/landing/customer-focus-building-a-trusted-brand-and-addressing-operational-resilience",
    component: _459eabdc,
    name: "lang-landing-customer-focus-building-a-trusted-brand-and-addressing-operational-resilience"
  }, {
    path: "/:lang/landing/download-webinar-rethinking-a-platform-approach-to-payments",
    component: _459eabdc,
    name: "lang-landing-download-webinar-rethinking-a-platform-approach-to-payments"
  }, {
    path: "/:lang/landing/gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration1",
    component: _459eabdc,
    name: "lang-landing-gated-content-download-the-webinar-how-to-combat-financial-crime-through-data-sharing-and-collaboration1"
  }, {
    path: "/:lang/landing/ebaday",
    component: _459eabdc,
    name: "lang-landing-ebaday"
  }, {
    path: "/:lang/landing/how-industry-events-shape-form3s-customer-and-partner-focus",
    component: _459eabdc,
    name: "lang-landing-how-industry-events-shape-form3s-customer-and-partner-focus"
  }, {
    path: "/:lang/landing/lets-celebrate-diversity",
    component: _459eabdc,
    name: "lang-landing-lets-celebrate-diversity"
  }, {
    path: "/:lang/landing/why-orchestration-is-key-for-payment-modernization",
    component: _459eabdc,
    name: "lang-landing-why-orchestration-is-key-for-payment-modernization"
  }, {
    path: "/:lang/landing/datos",
    component: _459eabdc,
    name: "lang-landing-datos"
  }, {
    path: "/:lang/landing/helping-global-fintechs-shape-the-future-of-payments",
    component: _459eabdc,
    name: "lang-landing-helping-global-fintechs-shape-the-future-of-payments"
  }, {
    path: "/:lang/landing/our-next-milestone-cracking-the-us-market",
    component: _459eabdc,
    name: "lang-landing-our-next-milestone-cracking-the-us-market"
  }, {
    path: "/:lang/landing/fincrime360",
    component: _459eabdc,
    name: "lang-landing-fincrime360"
  }, {
    path: "/:lang/landing/preparing-for-a-year-of-regulatory-changes",
    component: _459eabdc,
    name: "lang-landing-preparing-for-a-year-of-regulatory-changes"
  }, {
    path: "/:lang/landing/key-payments-industry-predictions-for-2025",
    component: _459eabdc,
    name: "lang-landing-key-payments-industry-predictions-for-2025"
  }, {
    path: "/:lang/landing/nacha",
    component: _459eabdc,
    name: "lang-landing-nacha"
  }, {
    path: "/:lang/landing/managing-change-in-financial-markets-and-payment-regulation",
    component: _459eabdc,
    name: "lang-landing-managing-change-in-financial-markets-and-payment-regulation"
  }, {
    path: "/:lang/landing/reshaping-form3-to-achieve-profitability",
    component: _459eabdc,
    name: "lang-landing-reshaping-form3-to-achieve-profitability"
  }, {
    path: "/:lang/landing/money-2020",
    component: _459eabdc,
    name: "lang-landing-money-2020"
  }, {
    path: "/:lang/news/press-releases/form3s-unique-platform",
    component: _0f30e057,
    name: "lang-news/press-releases-form3s-unique-platform"
  }, {
    path: "/:lang/news/press-releases/gocardless-selects-form3-for-bacs-payment",
    component: _0f30e057,
    name: "lang-news/press-releases-gocardless-selects-form3-for-bacs-payment"
  }, {
    path: "/:lang/news/press-releases/form3-appoints-mark-fieldhouse-as-chief-revenue-officer",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-appoints-mark-fieldhouse-as-chief-revenue-officer"
  }, {
    path: "/:lang/news/press-releases/form3-series-c-extension",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-series-c-extension"
  }, {
    path: "/:lang/news/press-releases/datos-insights-2024-impact-award-for-best-app-prevention-innovation",
    component: _0f30e057,
    name: "lang-news/press-releases-datos-insights-2024-impact-award-for-best-app-prevention-innovation"
  }, {
    path: "/:lang/news/press-releases/currencycloud-partners-with-form3",
    component: _0f30e057,
    name: "lang-news/press-releases-currencycloud-partners-with-form3"
  }, {
    path: "/:lang/news/press-releases/form3-and-feedzai-launch-industry-first-app-fraud-solution",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-and-feedzai-launch-industry-first-app-fraud-solution"
  }, {
    path: "/:lang/news/press-releases/form3-appoints-anil-arora-as-non-executive-director",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-appoints-anil-arora-as-non-executive-director"
  }, {
    path: "/:lang/news/press-releases/klarna-european-payments",
    component: _0f30e057,
    name: "lang-news/press-releases-klarna-european-payments"
  }, {
    path: "/:lang/news/press-releases/thought-machine-partners-with-form3",
    component: _0f30e057,
    name: "lang-news/press-releases-thought-machine-partners-with-form3"
  }, {
    path: "/:lang/news/press-releases/visa-invests-in-form3-reducing-fraud-and-increasing-operational-efficiency",
    component: _0f30e057,
    name: "lang-news/press-releases-visa-invests-in-form3-reducing-fraud-and-increasing-operational-efficiency"
  }, {
    path: "/:lang/news/press-releases/form3-appoints-matt-tuck-as-its-new-chief-commercial-officer",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-appoints-matt-tuck-as-its-new-chief-commercial-officer"
  }, {
    path: "/:lang/news/press-releases/certification-for-federal-reserves-new-instant-payment-service",
    component: _0f30e057,
    name: "lang-news/press-releases-certification-for-federal-reserves-new-instant-payment-service"
  }, {
    path: "/:lang/news/press-releases/sumup-selects-form3-for-uk-payments-to-boost-growth",
    component: _0f30e057,
    name: "lang-news/press-releases-sumup-selects-form3-for-uk-payments-to-boost-growth"
  }, {
    path: "/:lang/news/press-releases/the-payments-association-whitepaper-in-collaboration-with-form3",
    component: _0f30e057,
    name: "lang-news/press-releases-the-payments-association-whitepaper-in-collaboration-with-form3"
  }, {
    path: "/:lang/news/press-releases/nationwide-building-society-accenture-form3",
    component: _0f30e057,
    name: "lang-news/press-releases-nationwide-building-society-accenture-form3"
  }, {
    path: "/:lang/news/press-releases/form3-signs-clarency-for-swift-api-solution",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-signs-clarency-for-swift-api-solution"
  }, {
    path: "/:lang/news/press-releases/soldo-partnership",
    component: _0f30e057,
    name: "lang-news/press-releases-soldo-partnership"
  }, {
    path: "/:lang/news/press-releases/form3-sponsors-payments-association-working-group-to-tackle-uk-digital-and-financial-crime",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-sponsors-payments-association-working-group-to-tackle-uk-digital-and-financial-crime"
  }, {
    path: "/:lang/news/press-releases/form3-secures-eur23-million-funding-to-continue-exponential-growth-journey",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-secures-eur23-million-funding-to-continue-exponential-growth-journey"
  }, {
    path: "/:lang/news/press-releases/form3-to-launch-cloud-native-api-swift-connectivity",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-to-launch-cloud-native-api-swift-connectivity"
  }, {
    path: "/:lang/news/press-releases/shawn-meyer-joins-form3-as-sales-specialist-in-the-us",
    component: _0f30e057,
    name: "lang-news/press-releases-shawn-meyer-joins-form3-as-sales-specialist-in-the-us"
  }, {
    path: "/:lang/news/press-releases/jeremy-bambace-joins-form3-as-a-us-product-manager",
    component: _0f30e057,
    name: "lang-news/press-releases-jeremy-bambace-joins-form3-as-a-us-product-manager"
  }, {
    path: "/:lang/news/press-releases/form3-joins-fednow-pilot-program-to-drive-modernization",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-joins-fednow-pilot-program-to-drive-modernization"
  }, {
    path: "/:lang/news/press-releases/seedrs-lhv-uk-fps",
    component: _0f30e057,
    name: "lang-news/press-releases-seedrs-lhv-uk-fps"
  }, {
    path: "/:lang/news/press-releases/miriam-sheril",
    component: _0f30e057,
    name: "lang-news/press-releases-miriam-sheril"
  }, {
    path: "/:lang/news/press-releases/form3-barclays-sepa-ebury",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-barclays-sepa-ebury"
  }, {
    path: "/:lang/news/press-releases/form3-hires-ex-swift-chief-executive-for-us-market",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-hires-ex-swift-chief-executive-for-us-market"
  }, {
    path: "/:lang/news/press-releases/form3-barclays-sepa-credit-transfer",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-barclays-sepa-credit-transfer"
  }, {
    path: "/:lang/news/press-releases/form3-simeon-lando",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-simeon-lando"
  }, {
    path: "/:lang/news/press-releases/form3-raises-160-million",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-raises-160-million"
  }, {
    path: "/:lang/news/press-releases/form3-mastercard-payport-gateway",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-mastercard-payport-gateway"
  }, {
    path: "/:lang/news/press-releases/form3-nationwide-strategic-partnership",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-nationwide-strategic-partnership"
  }, {
    path: "/:lang/news/press-releases/form3-expanded-leadership-team",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-expanded-leadership-team"
  }, {
    path: "/:lang/news/press-releases/form3-aion-bank-finances",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-aion-bank-finances"
  }, {
    path: "/:lang/news/press-releases/form3-mastercard-strategic-partnership",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-mastercard-strategic-partnership"
  }, {
    path: "/:lang/news/press-releases/form3-raise-33-million-lloyds-nationwide-83north",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-raise-33-million-lloyds-nationwide-83north"
  }, {
    path: "/:lang/news/press-releases/form3-lloyds-strategic-partnership",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-lloyds-strategic-partnership"
  }, {
    path: "/:lang/news/press-releases/form3-lhv-europe",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-lhv-europe"
  }, {
    path: "/:lang/news/press-releases/form3-aws-competency-status",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-aws-competency-status"
  }, {
    path: "/:lang/news/press-releases/payments-as-a-service-first-choice-for-financial-institutions",
    component: _0f30e057,
    name: "lang-news/press-releases-payments-as-a-service-first-choice-for-financial-institutions"
  }, {
    path: "/:lang/news/press-releases/form3-bonnie-mitchell-joins",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-bonnie-mitchell-joins"
  }, {
    path: "/:lang/news/press-releases/form3-and-bpc-announce-partnership-to-combine-expertise",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-and-bpc-announce-partnership-to-combine-expertise"
  }, {
    path: "/:lang/news/press-releases/form3-european-expansion",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-european-expansion"
  }, {
    path: "/:lang/news/press-releases/form3-raise-13million",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-raise-13million"
  }, {
    path: "/:lang/news/press-releases/form3-lhv-faster-payments-direct",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-lhv-faster-payments-direct"
  }, {
    path: "/:lang/news/press-releases/form3-mambu-real-time-payments",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-mambu-real-time-payments"
  }, {
    path: "/:lang/news/press-releases/form3-tandem-ux",
    component: _0f30e057,
    name: "lang-news/press-releases-form3-tandem-ux"
  }, {
    path: "/:lang/news/press-releases/ebury-form3-go-live",
    component: _0f30e057,
    name: "lang-news/press-releases-ebury-form3-go-live"
  }, {
    path: "/:lang/blog/culture/male-health",
    component: _2ed58028,
    name: "lang-blog/culture-male-health"
  }, {
    path: "/:lang/blog/culture/my-journey-as-a-ba-apprentice",
    component: _2ed58028,
    name: "lang-blog/culture-my-journey-as-a-ba-apprentice"
  }, {
    path: "/:lang/blog/culture/my-first-6-months",
    component: _2ed58028,
    name: "lang-blog/culture-my-first-6-months"
  }, {
    path: "/:lang/blog/culture/investment-time",
    component: _2ed58028,
    name: "lang-blog/culture-investment-time"
  }, {
    path: "/:lang/blog/culture/fr3shers",
    component: _2ed58028,
    name: "lang-blog/culture-fr3shers"
  }, {
    path: "/:lang/blog/culture/michael-mueller-story",
    component: _2ed58028,
    name: "lang-blog/culture-michael-mueller-story"
  }, {
    path: "/:lang/blog/culture/womens-health",
    component: _2ed58028,
    name: "lang-blog/culture-womens-health"
  }, {
    path: "/:lang/blog/culture/internal-mobility",
    component: _2ed58028,
    name: "lang-blog/culture-internal-mobility"
  }, {
    path: "/:lang/blog/culture/legal-team-apprentice",
    component: _2ed58028,
    name: "lang-blog/culture-legal-team-apprentice"
  }, {
    path: "/:lang/blog/culture/building-our-unique-security-team",
    component: _2ed58028,
    name: "lang-blog/culture-building-our-unique-security-team"
  }, {
    path: "/:lang/blog/culture/how-we-came-up-with-our-company-values",
    component: _2ed58028,
    name: "lang-blog/culture-how-we-came-up-with-our-company-values"
  }, {
    path: "/:lang/blog/culture/environmental-impact-and-earth-day",
    component: _2ed58028,
    name: "lang-blog/culture-environmental-impact-and-earth-day"
  }, {
    path: "/:lang/blog/culture/furry-friends-of-form3",
    component: _2ed58028,
    name: "lang-blog/culture-furry-friends-of-form3"
  }, {
    path: "/:lang/blog/culture/how-we-celebrated-lgbt-history-month-at-form3",
    component: _2ed58028,
    name: "lang-blog/culture-how-we-celebrated-lgbt-history-month-at-form3"
  }, {
    path: "/:lang/blog/culture/how-form3-is-shaping-a-more-inclusive-future-for-people",
    component: _2ed58028,
    name: "lang-blog/culture-how-form3-is-shaping-a-more-inclusive-future-for-people"
  }, {
    path: "/:lang/blog/culture/celebrating-womens-history-month-being-a-new-working",
    component: _2ed58028,
    name: "lang-blog/culture-celebrating-womens-history-month-being-a-new-working"
  }, {
    path: "/:lang/blog/culture/our-interview-process",
    component: _2ed58028,
    name: "lang-blog/culture-our-interview-process"
  }, {
    path: "/:lang/blog/culture/our-promise-to-you",
    component: _2ed58028,
    name: "lang-blog/culture-our-promise-to-you"
  }, {
    path: "/:lang/blog/culture/from-security-recruiter-to-vulnerability-analyst-at-form3",
    component: _2ed58028,
    name: "lang-blog/culture-from-security-recruiter-to-vulnerability-analyst-at-form3"
  }, {
    path: "/:lang/blog/culture/international-womens-day-2023",
    component: _2ed58028,
    name: "lang-blog/culture-international-womens-day-2023"
  }, {
    path: "/:lang/blog/culture/can-you-please-introduce-yourself-your-role-and-what",
    component: _2ed58028,
    name: "lang-blog/culture-can-you-please-introduce-yourself-your-role-and-what"
  }, {
    path: "/:lang/blog/culture/planning-our-learning-for-the-year-ahead",
    component: _2ed58028,
    name: "lang-blog/culture-planning-our-learning-for-the-year-ahead"
  }, {
    path: "/:lang/blog/culture/november-was-national-tree-week-at-form3",
    component: _2ed58028,
    name: "lang-blog/culture-november-was-national-tree-week-at-form3"
  }, {
    path: "/:lang/blog/culture/dream-remote-software-engineer-job",
    component: _2ed58028,
    name: "lang-blog/culture-dream-remote-software-engineer-job"
  }, {
    path: "/:lang/blog/culture/intentionally-international",
    component: _2ed58028,
    name: "lang-blog/culture-intentionally-international"
  }, {
    path: "/:lang/blog/culture/celebrating-500-employees",
    component: _2ed58028,
    name: "lang-blog/culture-celebrating-500-employees"
  }, {
    path: "/:lang/blog/culture/fostering-healthy-teams-at-form3",
    component: _2ed58028,
    name: "lang-blog/culture-fostering-healthy-teams-at-form3"
  }, {
    path: "/:lang/blog/culture/black-history-month-at-form3",
    component: _2ed58028,
    name: "lang-blog/culture-black-history-month-at-form3"
  }, {
    path: "/:lang/blog/culture/how-form3-holds-effective-meetings",
    component: _2ed58028,
    name: "lang-blog/culture-how-form3-holds-effective-meetings"
  }, {
    path: "/:lang/blog/culture/its-all-about-communication",
    component: _2ed58028,
    name: "lang-blog/culture-its-all-about-communication"
  }, {
    path: "/:lang/blog/culture/on-mental-health-as-a-manager",
    component: _2ed58028,
    name: "lang-blog/culture-on-mental-health-as-a-manager"
  }, {
    path: "/:lang/blog/culture/psychological-safety-at-form3",
    component: _2ed58028,
    name: "lang-blog/culture-psychological-safety-at-form3"
  }, {
    path: "/:lang/blog/culture/how-form3-is-supporting-its-teams-mental-health",
    component: _2ed58028,
    name: "lang-blog/culture-how-form3-is-supporting-its-teams-mental-health"
  }, {
    path: "/:lang/blog/culture/keeping-connected-in-a-remote-first-business",
    component: _2ed58028,
    name: "lang-blog/culture-keeping-connected-in-a-remote-first-business"
  }, {
    path: "/:lang/blog/culture/form3-cares-about-the-planet",
    component: _2ed58028,
    name: "lang-blog/culture-form3-cares-about-the-planet"
  }, {
    path: "/:lang/blog/culture/meet-form3s-esg-intern",
    component: _2ed58028,
    name: "lang-blog/culture-meet-form3s-esg-intern"
  }, {
    path: "/:lang/blog/culture/setting-our-team-up-for-successful-remote-work",
    component: _2ed58028,
    name: "lang-blog/culture-setting-our-team-up-for-successful-remote-work"
  }, {
    path: "/:lang/blog/culture/our-culture-of-continuous-learning",
    component: _2ed58028,
    name: "lang-blog/culture-our-culture-of-continuous-learning"
  }, {
    path: "/:lang/blog/culture/form3s-approach-to-giving-back",
    component: _2ed58028,
    name: "lang-blog/culture-form3s-approach-to-giving-back"
  }, {
    path: "/:lang/blog/culture/male-allies-at-form3-on-international-womens-day",
    component: _2ed58028,
    name: "lang-blog/culture-male-allies-at-form3-on-international-womens-day"
  }, {
    path: "/:lang/blog/culture/international-womens-day-spotlight-the-life-of-a",
    component: _2ed58028,
    name: "lang-blog/culture-international-womens-day-spotlight-the-life-of-a"
  }, {
    path: "/:lang/blog/culture/asynchronous-communication",
    component: _2ed58028,
    name: "lang-blog/culture-asynchronous-communication"
  }, {
    path: "/:lang/blog/culture/diversity-update-a-year-in-review",
    component: _2ed58028,
    name: "lang-blog/culture-diversity-update-a-year-in-review"
  }, {
    path: "/:lang/blog/culture/form3s-first-apprentice",
    component: _2ed58028,
    name: "lang-blog/culture-form3s-first-apprentice"
  }, {
    path: "/:lang/blog/culture/female-leadership-spotlight---penny-hughes",
    component: _2ed58028,
    name: "lang-blog/culture-female-leadership-spotlight---penny-hughes"
  }, {
    path: "/:lang/blog/culture/female-leadership-spotlight-eimear-oconnor",
    component: _2ed58028,
    name: "lang-blog/culture-female-leadership-spotlight-eimear-oconnor"
  }, {
    path: "/:lang/blog/culture/female-leadership-spotlight--bonnie-mitchell",
    component: _2ed58028,
    name: "lang-blog/culture-female-leadership-spotlight--bonnie-mitchell"
  }, {
    path: "/:lang/blog/culture/international-womens-day",
    component: _2ed58028,
    name: "lang-blog/culture-international-womens-day"
  }, {
    path: "/:lang/blog/culture/a-remote-first-culture",
    component: _2ed58028,
    name: "lang-blog/culture-a-remote-first-culture"
  }, {
    path: "/:lang/blog/culture/women-in-tech",
    component: _2ed58028,
    name: "lang-blog/culture-women-in-tech"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
